//Initialize
var storefront_access_token = "e75fd65fc7535d76e59d8daf86bea11b";
var shopify_login_client_id = "95ea2fe4-e5e6-4690-900c-dce9e7b3bb35";
var shopify_customer_shop_id = "77709541664";
var primaryDomainURL = "https://alfatah.pk";
var checkoutURL = "https://checkout.alfatah.pk/checkout/";
var orderStatusURL = "https://checkout.alfatah.pk/status/";
var paymentMethodsURL = "https://checkout.alfatah.pk/payment-methods";
var minimumCheckoutAmount = 1000;
var defaultShopifyStoreID = 85730525472;
var default_latitude = 31.5822892;
var default_longitude = 74.4835381;
var customerCartID = "";
var customerCart = {};
var selectedStoreLat;
var selectedStoreLong;
var sav_aff_cookie = getCookie('sav_aff_info');
var collection_identifier = 'gid://shopify/Collection/';
var product_identifier = 'gid://shopify/Product/';
var variant_identifier = 'gid://shopify/ProductVariant/';
var location_identifier = 'gid://shopify/Location/';
var cartLine_identifier = 'gid://shopify/CartLine/';
var shopify_customer_account_url = "https://shopify.com/authentication/" + shopify_customer_shop_id + "/";
var tpl_api_key = '$2a$10$kUUhU5gkf7QiOAV1eak3Fu8Pmxvk36RLB5h2WYGl92VkABFpBZSaG';
var infiniteScrollLoading = {}; 
var customerSavedAddresses = [];

if (Shopify.designMode) {
	var store_location_shopify = defaultShopifyStoreID;
  selectedStoreLat = parseFloat(default_latitude);
  selectedStoreLong = parseFloat(default_longitude);
} else {
	var store_location_shopify = getCookie('tech_andaz_store_id');
  if (store_location_shopify == null || store_location_shopify == undefined || store_location_shopify == '') {
    var store_location_shopify = defaultShopifyStoreID;
    selectedStoreLat = parseFloat(default_latitude);
    selectedStoreLong = parseFloat(default_longitude);
  } else {
    selectedStoreLat = parseFloat(getCookie('tech_andaz_store_lat'));
    selectedStoreLong = parseFloat(getCookie('tech_andaz_store_long'));
  }
}
var selected_store_location = location_identifier + store_location_shopify;
const shopifyClient = ShopifyStorefrontAPIClient.createStorefrontApiClient({
  storeDomain: "https://" + Shopify.shop,
  apiVersion: '2026-07',
  publicAccessToken: storefront_access_token,
  retries: 3
});

//Helper Functions
function setCookie(name, value, daysToExpire) {
    const encodedValue = encodeURIComponent(value);
    let cookieString = `${name}=${encodedValue}; path=/; SameSite=None; Secure`;

    if (daysToExpire) {
        const expires = new Date(Date.now() + daysToExpire * 720 * 60 * 60 * 1000);
        cookieString += `; expires=${expires.toUTCString()}`;
    }
    document.cookie = cookieString;
}
function getCookie(name) {
	const cookieArray = document.cookie.split('; ');
	for (const cookie of cookieArray) {
		const [cookieName, cookieValue] = cookie.split('=');
		if (cookieName === name) {
			const decodedValue = decodeURIComponent(cookieValue);
			return decodedValue;
		}
	}
	return null;
}
$.urlParam = function(name) {
	var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);
	if (results == null) {
		return null;
	}
	return decodeURI(results[1]) || 0;
};
function getUserIP(){
  return new Promise((resolve,reject) => {
      var tech_andaz_buyer_ip = getCookie('tech_andaz_buyer_ip');
      if (tech_andaz_buyer_ip == null || tech_andaz_buyer_ip == undefined || tech_andaz_buyer_ip == '' || tech_andaz_buyer_ip == 'null') {
        fetch('https://api.ipify.org?format=json')
        .then((response) => response.json())
        .then((data) => {
          setCookie('tech_andaz_buyer_ip', data.ip, 1);
          resolve(data.ip);
        })
        .catch((error) => {
          setCookie('tech_andaz_buyer_ip', "", 1);
          resolve("");
        });
      } else {
        resolve(tech_andaz_buyer_ip);
        return;
      }
  });
}
function removeQueryParams() {
  const currentUrl = new URL(window.location.href);
  currentUrl.search = '';
  window.history.pushState({}, '', currentUrl.toString());
}
function chunkArray(array, chunkSize) {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
}
function handleErrors(errors){
  var error_html = "";
  for(var i = 0; i < errors.graphQLErrors.length; i++){
    error_html += errors.graphQLErrors[i].message + "\n";
  }
  Notiflix.Notify.failure(error_html);
}
function formatPrice(price) {
  return parseFloat(price).toLocaleString('ur-PK', {
    style: 'currency',
    currency: 'PKR',
  }); 
}

//Login
function generateRandomCode() {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, byte => String.fromCharCode(byte)).join('');
}
function base64UrlEncode(str) {
  const base64 = btoa(str);
  return base64
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}
async function generateCodeChallenge(codeVerifier) {
  const digestOp = await crypto.subtle.digest(
    { name: "SHA-256" },
    new TextEncoder().encode(codeVerifier)
  );
  const hash = Array.from(new Uint8Array(digestOp), byte => String.fromCharCode(byte)).join('');
  return base64UrlEncode(hash);
}
function generateState() {
  const timestamp = Date.now().toString();
  const randomString = Math.random().toString(36).substring(2);
  return Promise.resolve(timestamp + randomString);
}
function generateNonce(length) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let nonce = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    nonce += characters.charAt(randomIndex);
  }
  return Promise.resolve(nonce);
}
async function redirectToLogin() {
  const state = await generateState();
  const nonce = await generateNonce(25);
  const authorizationRequestUrl = new URL(
    shopify_customer_account_url + `oauth/authorize`
  );
  authorizationRequestUrl.searchParams.append('scope', 'openid email customer-account-api:full');
  authorizationRequestUrl.searchParams.append('client_id', shopify_login_client_id);
  authorizationRequestUrl.searchParams.append('response_type', 'code');
  authorizationRequestUrl.searchParams.append('redirect_uri', primaryDomainURL + '/pages/account');
  authorizationRequestUrl.searchParams.append('state', state);
  authorizationRequestUrl.searchParams.append('nonce', nonce);
  const verifier = generateRandomCode();
  const challenge = await generateCodeChallenge(verifier);
  localStorage.setItem('code-verifier', verifier);
  authorizationRequestUrl.searchParams.append('code_challenge', challenge);
  authorizationRequestUrl.searchParams.append('code_challenge_method', 'S256');
  window.location.href = authorizationRequestUrl.toString();
}
async function processCustomerLogin(code, state) {
  $(".main-account-container").hide();
  $(".main-account-container.validateLogin").show();
  const decodedCode = decodeURIComponent(code);
  const body = new URLSearchParams();
  body.append('grant_type', 'authorization_code');
  body.append('client_id', shopify_login_client_id);
  body.append('redirect_uri', primaryDomainURL + '/pages/account');
  body.append('code', decodedCode);
  const codeVerifier = localStorage.getItem('code-verifier');
  body.append('code_verifier', codeVerifier);
  const headers = {
    'content-type': 'application/x-www-form-urlencoded',
  };
  const response = await fetch(shopify_customer_account_url + `oauth/token`, {
    method: 'POST',
    headers: headers,
    body,
  });
  removeQueryParams();
  const { access_token, expires_in, id_token, refresh_token } = await response.json();
  localStorage.setItem('customer_access_token', access_token);
  localStorage.setItem('customer_access_expires_in', expires_in);
  localStorage.setItem('customer_refresh_token', refresh_token);
  localStorage.setItem('customer_id_token', id_token);
  await updateCartCustomer();
  window.location.reload();
}
async function logoutUser(){
  return new Promise(async (resolve,reject) => {
    const customer_id_token = localStorage.getItem('customer_id_token');
    const authorizationRequestUrl = new URL(
      shopify_customer_account_url + `logout`
    );
    authorizationRequestUrl.searchParams.append('id_token_hint', customer_id_token);
    authorizationRequestUrl.searchParams.append('post_logout_redirect_uri', primaryDomainURL);
    localStorage.removeItem('customer_access_token');
    localStorage.removeItem('customer_access_expires_in');
    localStorage.removeItem('customer_refresh_token');
    localStorage.removeItem('customer_id_token');
    localStorage.removeItem('code-verifier');

    const customerAttr = {
      attributes: {
        'customer_access_token': ""
      }
    };
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(customerAttr)
    })
    .then(response => {
      if (!response.ok) {
        Notiflix.Notify.failure('Unable to logout user!');
        resolve();
      }
      return response.json();
    })
    .then(data => {
      resolve(customerCart);
      return;
    })
    .catch(error => {
      Notiflix.Notify.failure('Unable to logout user!');
      resolve(customerCart);
      return;
    });
    window.location.href = authorizationRequestUrl.toString();
  });
}
function getCustomer(){
  return new Promise(async (resolve,reject) => {
    var customerAccessToken = localStorage.getItem('customer_access_token');
    const response = await fetch(
    'https://shopify.com/' + shopify_customer_shop_id + '/account/customer/api/2026-01/graphql',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: customerAccessToken,
        },
        body: JSON.stringify({
          operationName: 'customerQuery',
          query: `query { 
              customer {
                id
                creationDate
                displayName
                firstName
                lastName
                emailAddress {
                  emailAddress
                }
                phoneNumber {
                  phoneNumber
                }
                addresses: metafield(key: "addresses", namespace: "custom") {
                  value
                }
                tags
              }
          }`,
          variables: {
            
          },
        }),
      },
    );
    if (!response.ok) {
      const customerAttr = {
        attributes: {
          'customer_access_token': ""
        }
      };
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(customerAttr)
      })
      .then(response => {
        if (!response.ok) {
          resolve();
        }
        return response.json();
      })
      .then(data => {
        refreshCustomerToken();
        return;
      })
      .catch(error => {
        refreshCustomerToken();
        return;
      });
    }
    const data = await response.json();
    const id = data?.data?.customer?.id ?? null;
    const email = data?.data?.customer?.emailAddress?.emailAddress ?? null;
    const phoneNumber = data?.data?.customer?.phoneNumber?.phoneNumber ?? null; 
    const tags = data?.data?.customer?.tags ?? []; 
    const addresses = data?.data?.customer?.addresses?.value ? JSON.parse(data?.data?.customer?.addresses?.value) :  []; 
    const creationDate = data?.data?.customer?.creationDate ?? null;
    const displayName = data?.data?.customer?.displayName ?? null;
    const firstName = data?.data?.customer?.firstName ?? null;
    const lastName = data?.data?.customer?.lastName ?? null;
    resolve({id:id, email: email, phone: phoneNumber, tags: tags, addresses: addresses, creationDate: creationDate, displayName: displayName, firstName: firstName, lastName: lastName});
    return;
  });
}
function getCustomerOrders(cursor = null) {
  return new Promise(async (resolve, reject) => {
    var customerAccessToken = localStorage.getItem('customer_access_token');
    let cursorQueryPart = cursor ? `, after: "${cursor}"` : '';
    const query = `
      query {
        customer {
          orders(first: 10, sortKey: CREATED_AT, reverse: true${cursorQueryPart}) {
            nodes {
              id
              name
              email
              createdAt
              financialStatus
              fulfillmentStatus
              totalPrice  { amount currencyCode }
              order_secret_key: metafield(namespace: "custom", key: "order_secret_key") { value }
              cart_id: metafield(namespace: "custom", key: "cart_id") { value }
              order_status: metafield(namespace: "custom", key: "order_status") { value }
              order_method: metafield(namespace: "custom", key: "order_method") { value }
            }

            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
      }
    `;

    const response = await fetch(
      `https://shopify.com/${shopify_customer_shop_id}/account/customer/api/2026-01/graphql`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: customerAccessToken,
        },
        body: JSON.stringify({
          operationName: 'customerQuery',
          query: query,
          variables: {},
        }),
      }
    );

    if (!response.ok) {
      Notiflix.Notify.failure('Error fetching your orders!');
      resolve();
      return;
    }

    const data = await response.json();
    const orders = data?.data?.customer?.orders?.nodes ?? null;
    const pageInfo = data?.data?.customer?.orders?.pageInfo ?? {endCursor: "", hasNextPage: false};
    resolve({orders:orders, pageInfo: pageInfo});
    return;


    resolve(data);
  });
}
async function getCustomerOrderByID(gid) {
  return new Promise(async (resolve, reject) => {
    const customerAccessToken = localStorage.getItem('customer_access_token');
    let allLineItems = [];
    let hasNextPage = true;
    let endCursor = null;

    try {
      while (hasNextPage) {
        const query = `
          query {
            order(id: "${gid}") {
              billingAddress { formatted phoneNumber city name country address1 address2 }
              cancelledAt
              cancelReason
              createdAt
              financialStatus
              fulfillmentStatus
              id
              name
              number
              phone
              email
              processedAt
              shippingAddress { formatted phoneNumber city name country address1 address2 }
              statusPageUrl
              subtotal { amount }
              totalPrice { amount }
              totalRefunded { amount }
              totalShipping { amount }
              totalTax { amount }
              totalTip { amount }
              discountApplications(first: 20) {
              edges {
                node {
                  __typename
                  ... on DiscountCodeApplication {
                    code
                    value {
                      ... on MoneyV2 {
                        amount
                        currencyCode
                      }
                    }
                  }
                  ... on ManualDiscountApplication {
                    title
                    value {
                      ... on MoneyV2 {
                        amount
                        currencyCode
                      }
                    }
                  }
                  ... on ScriptDiscountApplication {
                    title
                    value {
                      ... on MoneyV2 {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
            }
              transactions { createdAt kind status type }
              updatedAt
              lineItems(first: 250${endCursor ? `, after: "${endCursor}"` : ""}) {
                edges {
                  node {
                    currentTotalPrice { amount }
                    id
                    image {
                      src
                    }
                    name
                    presentmentTitle
                    price { amount }
                    quantity
                    title
                    totalPrice { amount }
                    totalDiscount { amount }
                    unitPrice { price { amount } }
                    variantId
                    variantTitle
                  }
                }
                pageInfo {
                  hasNextPage
                  endCursor
                }
              }
            }
          }
        `;

        const response = await fetch(
          `https://shopify.com/${shopify_customer_shop_id}/account/customer/api/2026-01/graphql`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: customerAccessToken,
            },
            body: JSON.stringify({ operationName: 'customerQuery', query }),
          }
        );

        if (!response.ok) {
          Notiflix.Notify.failure('Error fetching your orders!');
          resolve();
          return;
        }

        const data = await response.json();
        const order = data.data.order;

        // Add line items to our array
        order.lineItems.edges.forEach(edge => allLineItems.push(edge.node));

        // Update pagination info
        hasNextPage = order.lineItems.pageInfo.hasNextPage;
        endCursor = order.lineItems.pageInfo.endCursor;

        // If first batch, store the rest of the order data
        if (!resolve.orderData) resolve.orderData = { ...order };
      }

      // Replace lineItems with all fetched items
      resolve.orderData.lineItems = allLineItems;
      resolve(resolve.orderData);
    } catch (err) {
      Notiflix.Notify.failure('Error fetching your orders!');
      reject(err);
    }
  });
}
function updateCartCustomer(){
  return new Promise(async (resolve,reject) => {
    var customer = await getCustomer();
    customerCartID = getCookie('tech_andaz_checkout_id');
    var customerAccessToken = localStorage.getItem('customer_access_token');
    const cartQuery = `
      mutation attachCustomerToCart($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!) {
        cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {
          cart {
            buyerIdentity {
              email
              phone
              customer {
                firstName
                displayName
                id
              }
            }
            cost {
              subtotalAmount {
                amount
              }
              totalAmount {
                amount
              }
              checkoutChargeAmount {
                amount
              }
            }
            discountAllocations {
              targetType
              discountedAmount {
                amount
              }
              ... on CartAutomaticDiscountAllocation {
                title
                discountedAmount {
                  amount
                }
                targetType
              }
              ... on CartCodeDiscountAllocation {
                code
                discountedAmount {
                  amount
                }
              }
              ... on CartCustomDiscountAllocation {
                title
                discountedAmount {
                  amount
                }
              }
            }
            attributes {
              key
              value
            }
            id
            note
            totalQuantity
          }
        }
      }`;
    var settings = {
      variables: 
        {
          cartId: customerCartID,
          buyerIdentity: {
            customerAccessToken: customerAccessToken,
            email: customer.email,
            phone: customer.phone,
          },
      }
    };
    const {data, errors, extensions} = await shopifyClient.request(cartQuery, settings);
    if (errors) {
      handleErrors(errors);
      return;
    }
    customerCart = data.cartBuyerIdentityUpdate.cart;
    customerCart.lines = await getCartLineItems();

    const customerAttr = {
      attributes: {
        'customer_access_token': customerAccessToken
      }
    };
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(customerAttr)
    })
    .then(response => {
      if (!response.ok) {
        Notiflix.Notify.failure('Unable to login user!');
        resolve();
      }
      return response.json();
    })
    .then(data => {
      resolve(customerCart);
      return;
    })
    .catch(error => {
      Notiflix.Notify.failure('Unable to login user!');
      resolve(customerCart);
      return;
    });
  });
}
function destroyUser(){
  return new Promise(async (resolve,reject) => {
    localStorage.removeItem('customer_access_token');
    localStorage.removeItem('customer_access_expires_in');
    localStorage.removeItem('customer_refresh_token');
    localStorage.removeItem('customer_id_token');
    localStorage.removeItem('code-verifier');
    const customerAttr = {
      attributes: {
        'customer_access_token': ""
      }
    };
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(customerAttr)
    })
    .then(response => {
      if (!response.ok) {
        resolve();
      }
      return response.json();
    })
    .then(data => {
      resolve();
      return;
    })
    .catch(error => {
      resolve();
      return;
    });
  });
}
async function refreshCustomerToken(){
  Notiflix.Loading.standard('Please wait...');
  var customerRefreshToken = localStorage.getItem('customer_refresh_token')
  if(customerRefreshToken != null && customerRefreshToken != "" && customerRefreshToken != undefined){
    const body = new URLSearchParams();
    body.append('grant_type', 'refresh_token');
    body.append('client_id', shopify_login_client_id);
    body.append('refresh_token', customerRefreshToken);
    const response = await fetch(shopify_customer_account_url + 'oauth/token', {
      method: 'POST',
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body,
    });
    const data = await response.json();
    if (!response.ok) {
      await destroyUser();
      Notiflix.Loading.remove();
      return;
    }

    const {access_token, expires_in, id_token, refresh_token: newRefreshToken} = data;
    if (access_token) localStorage.setItem('customer_access_token', access_token);
    if (id_token) localStorage.setItem('customer_id_token', id_token);
    if (newRefreshToken) localStorage.setItem('customer_refresh_token', newRefreshToken);
    localStorage.setItem('customer_access_expires_in', expires_in);
    window.location.reload();
    Notiflix.Loading.remove();
    return;
  }
  await destroyUser();
  Notiflix.Loading.remove();
}

//Cart
function getCart(){
  return new Promise(async (resolve,reject) => {
    customerCartID = getCookie('tech_andaz_checkout_id');
    if (customerCartID != null && customerCartID != undefined && customerCartID != '') {
      const cartQuery = `
        query CartQuery($cartId: ID!) {
          cart(id: $cartId) {
            deliveryGroups(first: 250) {
                nodes {
                  deliveryOptions {
                    deliveryMethodType
                    title
                    handle
                    code
                  }
                }
              }
              buyerIdentity {
                deliveryAddressPreferences {
                  ... on MailingAddress {
                    id
                    firstName
                    lastName
                    phone
                    address1
                    address2
                    city
                  }
                }
                preferences {
                  delivery {
                    coordinates {
                      latitude
                      longitude
                      countryCode
                    }
                    pickupHandle
                  }
                }
                phone
                email
                countryCode
                customer {
                  tags
                  addresses(first: 250) {
                    nodes {
                      id
                      firstName
                      lastName
                      phone
                      address1
                      address2
                      city
                    }
                  }
                  defaultAddress {
                    id
                    firstName
                    lastName
                    phone
                    address1
                    address2
                    city
                  }
                }
              }
              cost {
                subtotalAmount {
                  amount
                }
                totalAmount {
                  amount
                }
                checkoutChargeAmount {
                  amount
                }
              }
              discountAllocations {
                targetType
                discountedAmount {
                  amount
                }
                ... on CartAutomaticDiscountAllocation {
                  title
                  discountedAmount {
                    amount
                  }
                  targetType
                }
                ... on CartCodeDiscountAllocation {
                  code
                  discountedAmount {
                    amount
                  }
                }
                ... on CartCustomDiscountAllocation {
                  title
                  discountedAmount {
                    amount
                  }
                }
              }
              attributes {
                key
                value
              }
              id
              note
              totalQuantity
          }
        }`;
      var settings = {
        variables: {
          cartId: customerCartID,
        },
      };
      const {data, errors, extensions} = await shopifyClient.request(cartQuery, settings);
      if (errors) {
        handleErrors(errors);
        return;
      }
      customerCart = data.cart;
      for(var i = 0; i < customerCart.attributes.length; i++){
        if(customerCart.attributes[i].key == "order_completed" && customerCart.attributes[i].value == "true"){
          setCookie('tech_andaz_checkout_id', "", 1);
          setCookie('tech_andaz_store_id', "", 1);
          setCookie('tech_andaz_store_lat', "", 1);
          setCookie('tech_andaz_store_long', "", 1);
          setCookie('tech_andaz_buyer_ip', "", 1);
          setCookie('cart', "", 1);
          window.location.reload();
        }
      }
      customerCart.lines = await getCartLineItems();
      document.dispatchEvent(new CustomEvent("fetchCartCompleted", { detail: { status: 1 } }));
      resolve(customerCart);
      return;
    } else {
      await createCart();
      resolve(customerCart);
    }    
  });
}
function getCartLineItems(){
  return new Promise(async (resolve,reject) => {
    const lineItemQuery = `query CartLines ($cartId: ID!, $numItems: Int!, $afterCursor: String){
      cart(id: $cartId) {
        lines(first: $numItems, after: $afterCursor) {
          nodes {
            id
            merchandise {
              ... on ProductVariant {
                id
                title
                product {
                  id
                  vendor
                  tags
                }
              }
            }
            quantity
            cost {
              amountPerQuantity {
                amount
                currencyCode
              }
              compareAtAmountPerQuantity {
                amount
                currencyCode
              }
              subtotalAmount {
                amount
                currencyCode
              }
              totalAmount {
                currencyCode
                amount
              }
            }
            discountAllocations {
              discountedAmount {
                amount
                currencyCode
              }
              ... on CartAutomaticDiscountAllocation {
                title
                discountedAmount {
                  amount
                }
                targetType
              }
              ... on CartCodeDiscountAllocation {
                code
                discountedAmount {
                  amount
                }
              }
              ... on CartCustomDiscountAllocation {
                title
                discountedAmount {
                  amount
                }
              }
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }  
    }`;
    let hasNextPage = true, afterCursor = null;
    var lineItems = [];
    while (hasNextPage) {
      const {data, errors} = await shopifyClient.request(lineItemQuery, {
        variables: {
          cartId: customerCartID,
          numItems: 250, 
          afterCursor
        },
      });
      data.cart.lines.nodes.forEach((line) => {
        lineItems.push(line);
      });
      if (data.cart.lines.pageInfo.hasNextPage) {
        afterCursor = data.cart.lines.pageInfo.endCursor;
      } else {
        hasNextPage = false;
      }
    }
    resolve(lineItems);
  });
}
async function createCart(){
  return new Promise(async (resolve,reject) => {
    customerCartID = getCookie('tech_andaz_checkout_id');
    if (customerCartID == null ||customerCartID == undefined || customerCartID == '') {
      await getUserIP();
      var tech_andaz_buyer_ip = getCookie('tech_andaz_buyer_ip');
      const cartCreateMutation = `
        mutation ($input: CartInput!, $country: CountryCode, $language: LanguageCode)
        @inContext(country: $country, language: $language) {
          cartCreate(input: $input) {
            userErrors {
              message
              code
              field
            }
            cart {
              id
              checkoutUrl
            }
          }
        }
      `;
      var settings = {
        variables: {
          input: {},
          country: 'PK',
          language: 'EN',
        },
      };
      if(tech_andaz_buyer_ip){
        settings.headers = {
          'Shopify-Storefront-Buyer-IP': tech_andaz_buyer_ip,
        };
      }
      const {data, errors, extensions} = await shopifyClient.request(cartCreateMutation, settings);
      if (errors) {
        handleErrors(errors);
        return;
      }
      setCookie('tech_andaz_checkout_id', data.cartCreate.cart.id, 1);
      if (sav_aff_cookie != null && sav_aff_cookie != undefined && sav_aff_cookie == '') {
        await addUpdateCartAttribute([
          {
            key: "sav_aff_info",
            value: sav_aff_cookie
          }
        ]);
      }
      var cart = await getCart();
      resolve(cart);
    } else {
      var cart = await getCart();
      resolve(cart);
    }
  });
}
function addUpdateCartAttribute(attributeArray){
  return new Promise(async (resolve,reject) => {
    customerCartID = getCookie('tech_andaz_checkout_id');
    const cartQuery = `
      mutation AddCartAttribute($cartId: ID!, $attributes: [AttributeInput!]!) {
        cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
          cart {
            id
            attributes {
              key
              value
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `;
    var settings = {
      variables: {
        cartId: customerCartID,
        attributes: attributeArray
      },
    };
    const {data, errors, extensions} = await shopifyClient.request(cartQuery, settings);
    if (errors) {
      handleErrors(errors);
      return;
    }
    resolve(data.cartAttributesUpdate);
    return;
  });
}
function cartLinesAdd(variant_id, quantity, attributes = []) {
  return new Promise(async (resolve,reject) => {
    customerCartID = getCookie('tech_andaz_checkout_id');
    var locationCheck = await checkIfCartLocationIsSet();
    if(locationCheck == 0){
      Notiflix.Notify.failure('You must add your address first!');
      $(".alaftah-order-type-wrap").click();
      resolve({status: 0, customerCart: customerCart});
      return;
    }
    if(cartLocation_order_method != 'pickup') {
      var expressCheck = await checkIfExpressStillAvailable();
      if(expressCheck == false){
        Notiflix.Notify.failure('Express delivery is no longer available. Please choose a different address or delivery method.');
        $(".alaftah-order-type-wrap").click();
        resolve({status: 0, customerCart: customerCart});
        return;
      }
    }
    var checkQurbaniItems = await getCartLineItems();
    if (checkQurbaniItems.length > 0) {
        let cartHasQurbani = checkQurbaniItems.some(item => {
            const product = item.merchandise.product;
            return product.vendor === "Qurbani-Project" || product.tags?.includes("Qurbani-Project");
        });
        var newProductsInfo = await getProductVariantInformation(variant_id);
        if(newProductsInfo.length > 0) {
          const newProduct = newProductsInfo[0].product;
          let newIsQurbani = newProduct.vendor === "Qurbani-Project" || newProduct.tags?.includes("Qurbani-Project");
          if (!cartHasQurbani && newIsQurbani) {
              Notiflix.Notify.failure('You cannot add Qurbani items with regular products');
              $(".alaftah-order-type-wrap").click();
              resolve({status: 0, customerCart: customerCart});
              return;
          } else if (cartHasQurbani && !newIsQurbani) {
              Notiflix.Notify.failure('You cannot add Regular items with qurbani products');
              $(".alaftah-order-type-wrap").click();
              resolve({status: 0, customerCart: customerCart});
              return;
          }
          if(newIsQurbani && cartLocation_order_method != 'pickup') {
            Notiflix.Notify.failure('Qurbani items can only be ordered through Self Pickup Order Type');
            $(".alaftah-order-type-wrap").click();
            resolve({status: 0, customerCart: customerCart});
            return;
          }
        }
    } else {
      var newProductsInfo = await getProductVariantInformation(variant_id);
      if(newProductsInfo.length > 0) {
        const newProduct = newProductsInfo[0].product;
        let newIsQurbani = newProduct.vendor === "Qurbani-Project" || newProduct.tags?.includes("Qurbani-Project");
        if(newIsQurbani && cartLocation_order_method != 'pickup') {
          Notiflix.Notify.failure('Qurbani items can only be ordered through Self Pickup Order Type');
          $(".alaftah-order-type-wrap").click();
          resolve({status: 0, customerCart: customerCart});
          return;
        }
      }

    }
    var inCartQuantity = 0;
    for(var i = 0; i < customerCart.lines.length; i++){
      if(customerCart.lines[i].merchandise.id == variant_identifier + (variant_id.replace(variant_identifier, ""))){
        inCartQuantity = customerCart.lines[i].quantity
      }
    }
    var newQuantity = inCartQuantity + quantity;
    var availableQuantity = await getProductVariantQuantitiesAtLocation(variant_id);
    if(availableQuantity.length > 0){
      availableQuantity = availableQuantity[0];
    } else {
      availableQuantity = 0;
    }
    if(newQuantity > availableQuantity.quantityAvailable){
      Notiflix.Notify.failure('Only ' + availableQuantity.quantityAvailable + ' items are available in stock!');
      resolve({status: 0, customerCart: customerCart});
      return;
    }
    const cartQuery = `
      mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
        cartLinesAdd(cartId: $cartId, lines: $lines) {
          cart {
            buyerIdentity {
              email
              phone
              customer {
                firstName
                displayName
                id
              }
            }
            cost {
              subtotalAmount {
                amount
              }
              totalAmount {
                amount
              }
              checkoutChargeAmount {
                amount
              }
            }
            discountAllocations {
              targetType
              discountedAmount {
                amount
              }
              ... on CartAutomaticDiscountAllocation {
                title
                discountedAmount {
                  amount
                }
                targetType
              }
              ... on CartCodeDiscountAllocation {
                code
                discountedAmount {
                  amount
                }
              }
              ... on CartCustomDiscountAllocation {
                title
                discountedAmount {
                  amount
                }
              }
            }
            attributes {
              key
              value
            }
            id
            note
            totalQuantity
          }
          userErrors {
            field
            message
          }
        }
      }`;
    var settings = {
      variables: 
        {
          cartId: customerCartID,
          lines: [
            {
              attributes: attributes,
              merchandiseId: variant_id.startsWith(variant_identifier) ? variant_id : variant_identifier + variant_id,
              quantity: quantity,
            }
          ]
      }
    };
    const {data, errors, extensions} = await shopifyClient.request(cartQuery, settings);
    if (errors) {
      handleErrors(errors);
      resolve({status: 0, customerCart: customerCart});
      return;
    }
    customerCart = data.cartLinesAdd.cart;
    customerCart.lines = await getCartLineItems();
    Notiflix.Notify.success('Product has been added to your cart!');
    resolve({status: 1, customerCart: customerCart});
    return;
  });
}
function cartLinesUpdate(cartLineID, quantity, attributes = []){
  return new Promise(async (resolve,reject) => {
    customerCartID = getCookie('tech_andaz_checkout_id');
    var locationCheck = await checkIfCartLocationIsSet();
    if(locationCheck == 0){
      Notiflix.Notify.failure('You must add your address first!');
      $(".alaftah-order-type-wrap").click();
      resolve({status: 0, customerCart: customerCart});
      return;
    }
    if(cartLocation_order_method != 'pickup') {
      var expressCheck = await checkIfExpressStillAvailable();
      if(expressCheck == false){
        Notiflix.Notify.failure('Express delivery is no longer available. Please choose a different address or delivery method.');
        $(".alaftah-order-type-wrap").click();
        resolve({status: 0, customerCart: customerCart});
        return;
      }
    }
    var current_cart = await getCart();
    if(cartLineID == undefined || cartLineID == null) {
      $(this).html();
      return;
    }
    for(var i = 0; i < current_cart.lines.length; i++){
      if(current_cart.lines[i].id == (cartLineID.startsWith(cartLine_identifier) ? cartLineID : cartLine_identifier + cartLineID)){
        variant_id = current_cart.lines[i].merchandise.id;
        break;
      }
    }
    if(variant_id == ""){
      Notiflix.Notify.failure('Unable to update product');
      resolve({status: 0, customerCart: customerCart});
      return;
    }
    var availableQuantity = await getProductVariantQuantitiesAtLocation(variant_id);
    if(availableQuantity.length > 0){
      availableQuantity = availableQuantity[0];
    } else {
      availableQuantity = 0;
    }
    if(quantity > availableQuantity.quantityAvailable){
      Notiflix.Notify.failure('Only ' + availableQuantity.quantityAvailable + ' items are available in stock!');
      resolve({status: 0, customerCart: customerCart});
      return;
    }
    const cartQuery = `
      mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
        cartLinesUpdate(cartId: $cartId, lines: $lines) {
          cart {
            buyerIdentity {
              email
              phone
              customer {
                firstName
                displayName
                id
              }
            }
            cost {
              subtotalAmount {
                amount
              }
              totalAmount {
                amount
              }
              checkoutChargeAmount {
                amount
              }
            }
            discountAllocations {
              targetType
              discountedAmount {
                amount
              }
              ... on CartAutomaticDiscountAllocation {
                title
                discountedAmount {
                  amount
                }
                targetType
              }
              ... on CartCodeDiscountAllocation {
                code
                discountedAmount {
                  amount
                }
              }
              ... on CartCustomDiscountAllocation {
                title
                discountedAmount {
                  amount
                }
              }
            }
            attributes {
              key
              value
            }
            id
            note
            totalQuantity
          }
          userErrors {
            field
            message
          }
        }
      }`;
    var settings = {
      variables: 
        {
          cartId: customerCartID,
          lines: [
            {
              attributes: attributes,
              id: cartLineID.startsWith(cartLine_identifier) ? cartLineID : cartLine_identifier + cartLineID,
              quantity: quantity,
            }
          ]
      }
    };
    const {data, errors, extensions} = await shopifyClient.request(cartQuery, settings);
    if (errors) {
      handleErrors(errors);
      resolve({status: 0, customerCart: customerCart});
      return;
    }
    customerCart = data.cartLinesUpdate.cart;
    customerCart.lines = await getCartLineItems();
    Notiflix.Notify.success('Product has been updated!');
    resolve({status: 1, customerCart: customerCart});
    return;
  });
}
function cartLinesRemove(cartLineIDs){
  return new Promise(async (resolve,reject) => {
    customerCartID = getCookie('tech_andaz_checkout_id');
    if (!Array.isArray(cartLineIDs)) {
      var lineIds = [cartLineID.startsWith(cartLine_identifier) ? cartLineID : cartLine_identifier + cartLineID];
    } else {
      var lineIds = [];
      for(var i = 0; i < cartLineIDs.length; i++){
        lineIds.push(cartLineIDs[i].startsWith(cartLine_identifier) ? cartLineIDs[i] : cartLine_identifier + cartLineIDs[i]);
      }
    }
    const cartQuery = `
      mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
        cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
          cart {
            buyerIdentity {
              email
              phone
              customer {
                firstName
                displayName
                id
              }
            }
            cost {
              subtotalAmount {
                amount
              }
              totalAmount {
                amount
              }
              checkoutChargeAmount {
                amount
              }
            }
            discountAllocations {
              targetType
              discountedAmount {
                amount
              }
              ... on CartAutomaticDiscountAllocation {
                title
                discountedAmount {
                  amount
                }
                targetType
              }
              ... on CartCodeDiscountAllocation {
                code
                discountedAmount {
                  amount
                }
              }
              ... on CartCustomDiscountAllocation {
                title
                discountedAmount {
                  amount
                }
              }
            }
            attributes {
              key
              value
            }
            id
            note
            totalQuantity
          }
          userErrors {
            field
            message
          }
        }
      }`;
    var settings = {
      variables: 
        {
          cartId: customerCartID,
          lineIds: lineIds
      }
    };
    const {data, errors, extensions} = await shopifyClient.request(cartQuery, settings);
    if (errors) {
      handleErrors(errors);
      return;
    }
    customerCart = data.cartLinesRemove.cart;
    customerCart.lines = await getCartLineItems();
    resolve(customerCart);
    return;
  });
}
function validateCartForCheckout(){
  return new Promise(async (resolve,reject) => {
      Notiflix.Loading.standard('Please wait...');
      var cart = await getCart();
      var lineItems = cart.lines;
      if(lineItems.length == 0){
        Notiflix.Notify.failure('Your cart is empty!');
        Notiflix.Loading.remove();
        resolve({status: 0});
        return;
      }
      if(cartLocation_order_method != 'pickup') {
        var expressCheck = await checkIfExpressStillAvailable();
        if(expressCheck == false){
          Notiflix.Notify.failure('Express delivery is no longer available. Please choose a different address or delivery method.');
          Notiflix.Loading.remove();
          $(".alaftah-order-type-wrap").click();
          resolve({status: 0});
          return;
        }
      }
      if(parseFloat(cart.cost.subtotalAmount.amount) < minimumCheckoutAmount){
        Notiflix.Notify.failure("Your order total must be at least " + formatPrice(minimumCheckoutAmount) + " to place this order.");
        Notiflix.Loading.remove();
        resolve({status: 0});
        return;
      }
      // minimumCheckoutAmount
      var variant_ids = [];
      var variantAvailability = {};
      for(var i = 0; i < lineItems.length; i++){
        variant_ids.push(lineItems[i].merchandise.id);
        variantAvailability[lineItems[i].merchandise.id] = {
          id: lineItems[i].merchandise.id.replace(variant_identifier, ""),
          title: lineItems[i].merchandise.title,
          quantityOrdered: lineItems[i].quantity,
          quantityAvailable: 0,
        };
      }
      var chunkedArrays = chunkArray(variant_ids,250);
      for(var i = 0; i < chunkedArrays.length; i++){
        var availability = await getProductVariantQuantitiesAtLocation(chunkedArrays[i]);
        for(var j = 0; j < availability.length; j++){
          if(availability[j].id in variantAvailability){
            variantAvailability[availability[j].id].quantityAvailable = availability[j].quantityAvailable;
            variantAvailability[availability[j].id].maxAllowed = availability[j].maxAllowed ? availability[j].maxAllowed : 99;
            variantAvailability[availability[j].id].minAllowed = availability[j].minAllowed ? availability[j].minAllowed : 1;
          }
        }
      }
      var failed_ids = [];
      var success_ids = [];
      for(var variant_id in variantAvailability){
        if(variantAvailability[variant_id].quantityOrdered > variantAvailability[variant_id].quantityAvailable){
          failed_ids.push(variantAvailability[variant_id]);
        } else if(variantAvailability[variant_id].quantityOrdered > variantAvailability[variant_id].maxAllowed){
          failed_ids.push(variantAvailability[variant_id]);
        } else if(variantAvailability[variant_id].quantityOrdered < variantAvailability[variant_id].minAllowed){
          failed_ids.push(variantAvailability[variant_id]);
        } else {
          success_ids.push(variantAvailability[variant_id]);
        }
      }
      resolve({status: 1, success: success_ids, failed: failed_ids});
  });
}
function checkIfCartLocationIsSet(){
	return new Promise(async (resolve, reject) => {
        var storeSelected = 0;
        outer: for(var i = 0; i < customerCart.attributes.length; i++){
          if(customerCart.attributes[i].key == "location_id" && customerCart.attributes[i].value != "" && customerCart.attributes[i].value != undefined && customerCart.attributes[i].value != null){
            for(var j = 0; j < all_store_locations.locations.length; j++){
              if(all_store_locations.locations[j].location_id == customerCart.attributes[i].value){
                storeSelected = 1;
                break outer;
              }
            }
          }
        }
        if(storeSelected == 0){
          await getCart();
          outer: for(var i = 0; i < customerCart.attributes.length; i++){
            if(customerCart.attributes[i].key == "location_id" && customerCart.attributes[i].value != "" && customerCart.attributes[i].value != undefined && customerCart.attributes[i].value != null){
              for(var j = 0; j < all_store_locations.locations.length; j++){
                if(all_store_locations.locations[j].location_id == customerCart.attributes[i].value){
                  storeSelected = 1;
                  break outer;
                }
              }
            }
          }
        }
        if(storeSelected == 0){
          resolve(0);
        } else {
          resolve(1);
        }
    });
}
async function getCartProductInformation(cart){
  return new Promise(async (resolve,reject) => {
    var lineItems = cart.lines;
    var variant_ids = [];
    for(var i = 0; i < lineItems.length; i++){
      variant_ids.push(lineItems[i].merchandise.id);
    }
    var productsInfo = await getProductVariantInformation(variant_ids);
    resolve(productsInfo);
  });
}
$(document).on('click', '.proceed_to_checkout', async function(){
  $(".cart-item").removeClass("itemError");
  var customerAccessTokenCheck = localStorage.getItem('customer_access_token')
      if(customerAccessTokenCheck != null && customerAccessTokenCheck != "" && customerAccessTokenCheck != undefined){
        console.log(checkoutURL + base64UrlEncode(customerCartID) + "?authToken=" + base64UrlEncode(customerAccessTokenCheck));
      } else {
        console.log(checkoutURL + base64UrlEncode(customerCartID));
      }
  var validation = await validateCartForCheckout();
  if(validation.status == 1){
    if(validation.failed.length == 0){
      var customerAccessTokenCheck = localStorage.getItem('customer_access_token')
      if(customerAccessTokenCheck != null && customerAccessTokenCheck != "" && customerAccessTokenCheck != undefined){
        window.location = checkoutURL + base64UrlEncode(customerCartID) + "?authToken=" + base64UrlEncode(customerAccessTokenCheck);
      } else {
        window.location = checkoutURL + base64UrlEncode(customerCartID);
      }
    } else {
      for(var i = 0; i < validation.failed.length; i++){
        if(validation.failed[i].quantityAvailable == 0){
          $(".product_warnings_cart[variant_id='" + validation.failed[i].id + "']").html(`<span class="weight-badge">Sold Out</span>`);
        } else if(validation.failed[i].quantityAvailable < validation.failed[i].quantityOrdered){
          $(".product_warnings_cart[variant_id='" + validation.failed[i].id + "']").html(`<span class="weight-badge">Only ${validation.failed[i].quantityAvailable} Available</span>`);
        } else if(validation.failed[i].quantityOrdered > validation.failed[i].maxAllowed){
          $(".product_warnings_cart[variant_id='" + validation.failed[i].id + "']").html(`<span class="weight-badge">Only ${validation.failed[i].maxAllowed} Available</span>`);
        } else if(validation.failed[i].quantityOrdered < validation.failed[i].minAllowed){
          $(".product_warnings_cart[variant_id='" + validation.failed[i].id + "']").html(`<span class="weight-badge">Minimum ${validation.failed[i].minAllowed} Need to Be Ordered</span>`);
        }
        $(".cart-item[variant_id='" + validation.failed[i].id + "']").addClass("itemError");
      }
      var cart_items = $(".total-cart-items").children('.cart-item');
      cart_items.sort(function(a, b){
          var aErr = $(a).hasClass('itemError') ? 1 : 0;
          var bErr = $(b).hasClass('itemError') ? 1 : 0;
          return bErr - aErr; 
      });
      $(".total-cart-items").append(cart_items);
      document.querySelector('.total-cart-items').scrollIntoView({
          behavior: 'smooth',
          block: 'start'
      });
      Notiflix.Notify.failure('There were errors in your cart. Please review and fix before proceeeding.');
      Notiflix.Loading.remove();
    }
  }
})

//Products
function getQueryFilters(){
	return new Promise((resolve, reject) => {
      const queryParams = new URLSearchParams(window.location.search);
      var filters = [{
        available:true
      }];
      var filter_price = {};
      var sort_key = "COLLECTION_DEFAULT";
      var reverse;
      queryParams.forEach((value, key) => {
        if (key == 'filter.v.price.gte') {
          if (value != '') {
            filter_price.min = parseFloat(value);
          }
        } else if (key == 'filter.v.price.lte') {
          if (value != '') {
            filter_price.max = parseFloat(value);
          }
        } else if (key.includes('filter.v.option')) {
          filters.push({
            variantOption: {
              name: key.substring(key.indexOf('filter.v.option') + 'filter.v.option'.length + 1),
              value: value,
            },
          });
        } else if (key.includes('filter.p.m')) {
          const parts = key.split('.');
          filters.push({
            productMetafield: {
              namespace: parts[3],
              key: parts[4],
              value: value,
            },
          });
        } else if (key.includes('filter.v.m')) {
          const parts = key.split('.');
          filters.push({
            variantMetafield: {
              namespace: parts[3],
              key: parts[4],
              value: value,
            },
          });
        } else if (key.includes('filter.p.tag')) {
          filters.push({
            tag: value,
          });
        } else if (key.includes('filter.p.product_type')) {
          filters.push({
            productType: value,
          });
        } else if (key.includes('filter.p.vendor')) {
          filters.push({
            productVendor: value,
          });
        } else if (key.includes('sort_by')) {
          const sort_parts = value.split('-');
          if (sort_parts[1] == 'descending') {
            reverse = true;
          } else {
            reverse = false;
          }
          if (sort_parts[0] == 'manual') {
            sort_key = 'MANUAL';
          } else if (sort_parts[0] == 'best-selling') {
            sort_key = 'BEST_SELLING';
          } else if (sort_parts[0] == 'title') {
            sort_key = 'TITLE';
          } else if (sort_parts[0] == 'price') {
            sort_key = 'PRICE';
          } else if (sort_parts[0] == 'created') {
            sort_key = 'CREATED';
          }
        }
      });
      if (Object.keys(filter_price).length > 0) {
        filters.push({
          price: filter_price,
        });
      }
      resolve({filters: filters, sortKey: sort_key, reverse: reverse});
  });
}
function getCollectionProducts(collection_id, cursor){
	return new Promise(async (resolve, reject) => {
      var queryFilters = await getQueryFilters();
      const productQuery = `
          query collectionProductsByLocation($collectionId: ID!, $filters: [ProductFilter!]!, $sortKey: ProductCollectionSortKeys, $reverse: Boolean, $afterCursor: String, $nearLat: GeoCoordinateInput) {
            collection(id: $collectionId) {
              products(filters: $filters, sortKey: $sortKey, reverse: $reverse, first: 50, after: $afterCursor) {
                nodes {
                  id
                  title
                  handle
                  availableForSale
                  priceRange {
                    minVariantPrice {
                      amount
                    }
                    maxVariantPrice {
                      amount
                    }
                  }
                  compareAtPriceRange {
                    maxVariantPrice {
                      amount
                    }
                    minVariantPrice {
                      amount
                    }
                  }
                  featuredImage {
                    src
                    altText
                    height
                    width
                  }
                  onlineStoreUrl
                  variantsCount {
                    count
                  }
                  variants(first: 250) {
                    nodes {
                      storeAvailability(near: $nearLat, first: 250) {
                        nodes {
                          available
                          quantityAvailable
                          location {
                            id
                          }
                        }
                      }
                      min_limit: metafield(key: "tech_andaz_variant_min_limit", namespace: "custom") {
                        value
                      }
                      max_limit: metafield(key: "tech_andaz_variant_max_limit", namespace: "custom") {
                        value
                      }
                      id
                      title
                      availableForSale
                      priceV2 {
                        amount
                      }
                      compareAtPriceV2 {
                        amount
                      }
                    }
                  }
                }
                pageInfo {
                  hasNextPage
                  endCursor
                }
              }
            }
          }
      `;
      const settings = {
        variables: {
          collectionId: collection_id.startsWith(collection_identifier) ? collection_id : collection_identifier + collection_id,
          filters: queryFilters.filters,
          sortKey: queryFilters.sortKey,
          reverse: queryFilters.reverse,
          afterCursor: cursor || null,
          nearLat: {
            latitude: selectedStoreLat,
            longitude: selectedStoreLong
          }
        },
      };
      const {data, errors, extensions} = await shopifyClient.request(productQuery, settings);
      if (errors) {
        handleErrors(errors);
        return;
      }
      var collectionProducts = data.collection.products.nodes;
      var pageInfo = data.collection.products.pageInfo;
      var products = [];
      outer: for(var i = 0; i < collectionProducts.length; i++){
        var product_availability = 0;
        if(collectionProducts[i].availableForSale == true){
          var variants = collectionProducts[i].variants.nodes;
          var organizedVariants = [];
          variantInner: for(var j = 0; j < variants.length; j++){
            var storeQuantity = 0;
            if(variants[j].availableForSale == true){
              var storeAvaiabilities = variants[j].storeAvailability.nodes;
              for(var k = 0; k < storeAvaiabilities.length; k++){
                if(storeAvaiabilities[k].location.id == selected_store_location && storeAvaiabilities[k].available == true){
                  collectionProducts[i].variants.nodes[j].storeAvailability = storeAvaiabilities[k].quantityAvailable;
                  product_availability = 1;
                  continue variantInner;
                }
              }
              collectionProducts[i].variants.nodes[j].storeAvailability = 0;
            }
          }
        }
        if(product_availability == 1){
          products.push(collectionProducts[i]);
        }
      }
      resolve({products: products, pageInfo: pageInfo});
    });
}
function getRecommendedProducts(product_id, intent){
	return new Promise(async (resolve, reject) => {
      if(intent == "" || intent == undefined || intent == null || (intent != "RELATED" && intent != "COMPLEMENTARY")){
        intent = "RELATED";
      }
      const productQuery = `
          query productRecommendations($product_id: ID!, $intent: ProductRecommendationIntent, $nearLat: GeoCoordinateInput) {
            productRecommendations(productId: $product_id, intent: $intent) {
              id
              title
              handle
              availableForSale
              priceRange {
                minVariantPrice {
                  amount
                }
                maxVariantPrice {
                  amount
                }
              }
              compareAtPriceRange {
                maxVariantPrice {
                  amount
                }
                minVariantPrice {
                  amount
                }
              }
              featuredImage {
                src
                altText
                height
                width
              }
              onlineStoreUrl
              variantsCount {
                count
              }
              variants(first: 250) {
                nodes {
                  storeAvailability(near: $nearLat, first: 250) {
                    nodes {
                      available
                      quantityAvailable
                      location {
                        id
                      }
                    }
                  }
                  id
                  title
                  availableForSale
                  priceV2 {
                    amount
                  }
                  compareAtPriceV2 {
                    amount
                  }
                  min_limit: metafield(key: "tech_andaz_variant_min_limit", namespace: "custom") {
                    value
                  }
                  max_limit: metafield(key: "tech_andaz_variant_max_limit", namespace: "custom") {
                    value
                  }
                }
              }
            }
          }
      `;
      const settings = {
        variables: {
          product_id: product_id.startsWith(product_identifier) ? product_id : product_identifier + product_id,
          intent: intent,
          nearLat: {
            latitude: selectedStoreLat,
            longitude: selectedStoreLong
          }
        },
      };
      const {data, errors, extensions} = await shopifyClient.request(productQuery, settings);
      if (errors) {
        handleErrors(errors);
        return;
      }
      var collectionProducts = data.productRecommendations;
      var products = [];
      outer: for(var i = 0; i < collectionProducts.length; i++){
        var product_availability = 0;
        if(collectionProducts[i].availableForSale == true){
          var variants = collectionProducts[i].variants.nodes;
          var organizedVariants = [];
          variantInner: for(var j = 0; j < variants.length; j++){
            var storeQuantity = 0;
            if(variants[j].availableForSale == true){
              var storeAvaiabilities = variants[j].storeAvailability.nodes;
              for(var k = 0; k < storeAvaiabilities.length; k++){
                if(storeAvaiabilities[k].location.id == selected_store_location && storeAvaiabilities[k].available == true){
                  collectionProducts[i].variants.nodes[j].storeAvailability = storeAvaiabilities[k].quantityAvailable;
                  product_availability = 1;
                  continue variantInner;
                }
              }
              collectionProducts[i].variants.nodes[j].storeAvailability = 0;
            }
          }
        }
        if(product_availability == 1){
          products.push(collectionProducts[i]);
        }
      }
      resolve({products: products});
    });
}
function getRelatedByCategoryProducts(product_id, maxResults = 12) {
  return new Promise(async (resolve, reject) => {
    try {
      // fetch the product collections to determine a category/collection
      const q = `
        query getProductCollections($productId: ID!) {
          product(id: $productId) {
            id
            productType
            collections(first: 1) {
              nodes {
                id
                handle
              }
            }
          }
        }
      `;
      const variables = { productId: product_id.startsWith(product_identifier) ? product_id : product_identifier + product_id };
      const { data, errors } = await shopifyClient.request(q, { variables });
      if (errors) { resolve({ products: [] }); return; }
      const productNode = data.product;
      if (!productNode || !productNode.collections || !productNode.collections.nodes || !productNode.collections.nodes.length) {
        // no collections - fallback not found
        resolve({ products: [] });
        return;
      }
      const collectionNode = productNode.collections.nodes[0];
      const collection_id = collectionNode.id;
      // use existing getCollectionProducts which already applies location & availability filtering
      const collection_response = await getCollectionProducts(collection_id);
      // filter out the current product itself
      const products = (collection_response.products || []).filter(p => p.id !== product_id);
      resolve({ products: products });
    } catch (e) {
      console.error('getRelatedByCategoryProducts error', e);
      resolve({ products: [] });
    }
  });
}
function getProduct(product_id){
	return new Promise(async (resolve, reject) => {
      const productQuery = `
          query getProduct($product_id: ID!, $nearLat: GeoCoordinateInput) {
            product(id: $product_id) {
              id
              title
              handle
              availableForSale
              priceRange {
                minVariantPrice {
                  amount
                }
                maxVariantPrice {
                  amount
                }
              }
              compareAtPriceRange {
                maxVariantPrice {
                  amount
                }
                minVariantPrice {
                  amount
                }
              }
              featuredImage {
                src
                altText
                height
                width
              }
              onlineStoreUrl
              variantsCount {
                count
              }
              variants(first: 250) {
                nodes {
                  storeAvailability(near: $nearLat, first: 250) {
                    nodes {
                      available
                      quantityAvailable
                      location {
                        id
                      }
                    }
                  }
                  id
                  title
                  availableForSale
                  sku
                  priceV2 {
                    amount
                  }
                  compareAtPriceV2 {
                    amount
                  }
                  image {
                    src
                    altText
                    width
                    height
                  }
                  selectedOptions {
                    name
                    value
                  }
                }
              }
            }
          }
      `;
      const settings = {
        variables: {
          product_id: product_id.startsWith(product_identifier) ? product_id : product_identifier + product_id,
          nearLat: {
            latitude: selectedStoreLat,
            longitude: selectedStoreLong
          }
        },
      };
      const {data, errors, extensions} = await shopifyClient.request(productQuery, settings);
      if (errors) {
        handleErrors(errors);
        return;
      }

      var product = data.product;
      var variants = product.variants.nodes;
      var organizedVariants = [];
      variantInner: for(var j = 0; j < variants.length; j++){
        if(variants[j].availableForSale == true){
          var storeAvaiabilities = variants[j].storeAvailability.nodes;
          for(var k = 0; k < storeAvaiabilities.length; k++){
            if(storeAvaiabilities[k].location.id == selected_store_location && storeAvaiabilities[k].available == true){
              product.variants.nodes[j].storeAvailability = storeAvaiabilities[k].quantityAvailable;
              product_availability = 1;
              continue variantInner;
            }
          }
          product.variants.nodes[j].availableForSale = false;
          product.variants.nodes[j].storeAvailability = 0;
        }
      }
      resolve(product);
    });
}
function getProductVariant(variant_id){
	return new Promise(async (resolve, reject) => {
      const productQuery = `
          query getProduct($variant_id: ID!, $nearLat: GeoCoordinateInput) {
            node(id: $variant_id) {
              ... on ProductVariant {
                storeAvailability(near: $nearLat, first: 250) {
                  nodes {
                    available
                    quantityAvailable
                    location {
                      id
                    }
                  }
                }
                id
                title
                availableForSale
                priceV2 {
                  amount
                }
                min_limit: metafield(key: "tech_andaz_variant_min_limit", namespace: "custom") {
                  value
                }
                max_limit: metafield(key: "tech_andaz_variant_max_limit", namespace: "custom") {
                  value
                }
                compareAtPriceV2 {
                  amount
                }
              }
            }
          }
      `;
      const settings = {
        variables: {
          variant_id: variant_id.startsWith(variant_identifier) ? variant_id : variant_identifier + variant_id,
          nearLat: {
            latitude: selectedStoreLat,
            longitude: selectedStoreLong
          }
        },
      };
      const {data, errors, extensions} = await shopifyClient.request(productQuery, settings);
      if (errors) {
        handleErrors(errors);
        return;
      }
      var variant = data.node;
      if(variant.availableForSale == true){
        var storeAvaiabilities = variant.storeAvailability.nodes;
        variant.storeAvailability = 0;
        for(var k = 0; k < storeAvaiabilities.length; k++){
          if(storeAvaiabilities[k].location.id == selected_store_location && storeAvaiabilities[k].available == true){
            variant.storeAvailability = storeAvaiabilities[k].quantityAvailable;
            product_availability = 1;
            break;
          }
        }
      } else {
        variant.storeAvailability = 0;
      }
      resolve(variant);
    });
}
function getProductVariantInformation(variant_ids){
	return new Promise(async (resolve, reject) => {
      if (!Array.isArray(variant_ids)) {
        variant_ids = [variant_ids];
      }
      var formattedVariantIds = [];
      for(var i = 0; i < variant_ids.length; i++){
        formattedVariantIds.push(variant_ids[i].startsWith(variant_identifier) ? variant_ids[i] : variant_identifier + variant_ids[i]);
      }
      const productQuery = `
          query getProduct($variant_id: [ID!]!, $nearLat: GeoCoordinateInput) {
            nodes(ids: $variant_id) {
              ... on ProductVariant {
                storeAvailability(near: $nearLat, first: 250) {
                  nodes {
                    available
                    quantityAvailable
                    location {
                      id
                    }
                  }
                }
                id
                title
                product {
                  title
                  onlineStoreUrl
                  vendor
                  tags
                }
                image {
                  src
                }
                availableForSale
                priceV2 {
                  amount
                  currencyCode
                }
                min_limit: metafield(key: "tech_andaz_variant_min_limit", namespace: "custom") {
                  value
                }
                max_limit: metafield(key: "tech_andaz_variant_max_limit", namespace: "custom") {
                  value
                }
                compareAtPriceV2 {
                  amount
                }
              }
            }
          }
      `;
      var chunkedArrays = chunkArray(formattedVariantIds,250);
      var allVariants = [];
      for(var i = 0; i < chunkedArrays.length; i++){
         const settings = {
          variables: {
            variant_id: chunkedArrays[i],
            nearLat: {
              latitude: selectedStoreLat,
              longitude: selectedStoreLong
            }
          },
        };
        const {data, errors, extensions} = await shopifyClient.request(productQuery, settings);
        if (errors) {
          handleErrors(errors);
          return;
        }
        var variants = data.nodes;
        var products = [];
        outer: for(var j = 0; j < variants.length; j++){
          if(variants[j] != null && variants[j] != undefined && variants[j] != ""){
            var storeAvaiabilities = variants[j].storeAvailability.nodes;
            for(var k = 0; k < storeAvaiabilities.length; k++){
              if(storeAvaiabilities[k].location.id == selected_store_location && storeAvaiabilities[k].available == true){
                variants[j].storeAvailability = storeAvaiabilities[k].quantityAvailable;
                products.push(variants[j]);
                continue outer;
              }
            }
            variants[j].storeAvailability = 0;
            products.push(variants[j]);
          }
        }
        allVariants = allVariants.concat(products);
      }
      resolve(allVariants);
    });
}
function getProductVariantQuantitiesAtLocation(variant_ids){
	return new Promise(async (resolve, reject) => {
      if (!Array.isArray(variant_ids)) {
        variant_ids = [variant_ids];
      }
      var formattedVariantIds = [];
      for(var i = 0; i < variant_ids.length; i++){
        formattedVariantIds.push(variant_ids[i].startsWith(variant_identifier) ? variant_ids[i] : variant_identifier + variant_ids[i]);
      }
      const productQuery = `
          query getProduct($variant_id: [ID!]!, $nearLat: GeoCoordinateInput) {
            nodes(ids: $variant_id) {
              ... on ProductVariant {
                storeAvailability(near: $nearLat, first: 250) {
                  nodes {
                    available
                    quantityAvailable
                    location {
                      id
                    }
                  }
                }
                min_limit: metafield(key: "tech_andaz_variant_min_limit", namespace: "custom") {
                  value
                }
                max_limit: metafield(key: "tech_andaz_variant_max_limit", namespace: "custom") {
                  value
                }
                id
              }
            }
          }
      `;
      var chunkedArrays = chunkArray(formattedVariantIds,250);
      var allVariants = [];
      for(var i = 0; i < chunkedArrays.length; i++){
         const settings = {
          variables: {
            variant_id: chunkedArrays[i],
            nearLat: {
              latitude: selectedStoreLat,
              longitude: selectedStoreLong
            }
          },
        };
        const {data, errors, extensions} = await shopifyClient.request(productQuery, settings);
        if (errors) {
          handleErrors(errors);
          return;
        }
        var variants = data.nodes;
        var products = [];
        outer: for(var j = 0; j < variants.length; j++){
          if(variants[j] != null && variants[j] != undefined && variants[j] != ""){
            var storeAvaiabilities = variants[j].storeAvailability.nodes;
            for(var k = 0; k < storeAvaiabilities.length; k++){
              if(storeAvaiabilities[k].location.id == selected_store_location && storeAvaiabilities[k].available == true){
                if(variants[j].max_limit == null) {
                    variants[j].max_limit = {
                      value:99
                    }
                }
                if(variants[j].min_limit == null) {
                    variants[j].min_limit = {
                      value:1
                    }
                }
                if(variants[j].max_limit != null && variants[j].max_limit.value != null && variants[j].max_limit.value < storeAvaiabilities[k].quantityAvailable){
                  storeAvaiabilities[k].quantityAvailable = variants[j].max_limit.value;
                }
                products.push({
                  id: variants[j].id,
                  quantityAvailable: storeAvaiabilities[k].quantityAvailable,
                  maxAllowed: variants[j].max_limit.value ? variants[j].max_limit.value : 99,
                  minAllowed: variants[j].min_limit.value ? variants[j].min_limit.value : 1,
                });
                continue outer;
              }
            }
            products.push({
              id: variants[j].id,
              quantityAvailable: 0,
            });
          }
        }
        allVariants = allVariants.concat(products);
      }
      resolve(allVariants);
    });
}

//Search
function predictiveSearch(searchTerm){
  return new Promise(async (resolve,reject) => {
    const cartQuery = `
      query searchQuery($searchTerm: String!, $nearLat: GeoCoordinateInput) {
        predictiveSearch(
          query: $searchTerm
          limitScope: ALL
          limit: 10
          types: [PRODUCT,QUERY]
          unavailableProducts: HIDE
          searchableFields: [TITLE,VARIANTS_TITLE]
        ) {
          queries {
            text
          }
          products {
            id
            title
            handle
            availableForSale
            priceRange {
              minVariantPrice {
                amount
              }
              maxVariantPrice {
                amount
              }
            }
            compareAtPriceRange {
              maxVariantPrice {
                amount
              }
              minVariantPrice {
                amount
              }
            }
            featuredImage {
              src
              altText
              height
              width
            }
            metafields(
              identifiers: [{key: "custom", namespace: "delivery_time"}, {key: "custom", namespace: "tech_andaz_product_min_limit"}, {key: "custom", namespace: "tech_andaz_product_max_limit"}]
            ) {
              key
              value
            }
            onlineStoreUrl
            variantsCount {
              count
            }
            variants(first: 250) {
              nodes {
                storeAvailability(near: $nearLat, first: 250) {
                  nodes {
                    available
                    quantityAvailable
                    location {
                      id
                    }
                  }
                }
                id
                title
                availableForSale
                priceV2 {
                  amount
                }
                compareAtPriceV2 {
                  amount
                }
              }
            }
          }
        }
    }`;
    var settings = {
      variables: {
        searchTerm: searchTerm,
        nearLat: {
          latitude: selectedStoreLat,
          longitude: selectedStoreLong
        }
      },
    };
    const {data, errors, extensions} = await shopifyClient.request(cartQuery, settings);
    if (errors) {
      handleErrors(errors);
      return;
    }
    var collectionProducts = data.predictiveSearch.products;
    var queries = data.predictiveSearch.queries;
    var products = [];
    outer: for(var i = 0; i < collectionProducts.length; i++){
      var product_availability = 0;
      if(collectionProducts[i].availableForSale == true){
        var variants = collectionProducts[i].variants.nodes;
        var organizedVariants = [];
        variantInner: for(var j = 0; j < variants.length; j++){
          var storeQuantity = 0;
          if(variants[j].availableForSale == true){
            var storeAvaiabilities = variants[j].storeAvailability.nodes;
            for(var k = 0; k < storeAvaiabilities.length; k++){
              if(storeAvaiabilities[k].location.id == selected_store_location && storeAvaiabilities[k].available == true){
                collectionProducts[i].variants.nodes[j].storeAvailability = storeAvaiabilities[k].quantityAvailable;
                product_availability = 1;
                continue variantInner;
              }
            }
            collectionProducts[i].variants.nodes[j].storeAvailability = 0;
          }
        }
      }
      if(product_availability == 1){
        products.push(collectionProducts[i]);
      }
    }
    resolve({products: products, queries: queries});
    return;
  });
}
function searchProducts(searchTerm, cursor){
	return new Promise(async (resolve, reject) => {
      var queryFilters = await getQueryFilters();
      const productQuery = `
          query searchProductsByLocation($searchTerm: String!, $filters: [ProductFilter!]!, $sortKey: SearchSortKeys,  $reverse: Boolean, $afterCursor: String, $nearLat: GeoCoordinateInput) {
            search(query: $searchTerm, productFilters: $filters, sortKey: $sortKey, reverse: $reverse, first: 50, after: $afterCursor, types: PRODUCT, unavailableProducts: HIDE) {
              nodes {
                ... on Product {
                  id
                  title
                  handle
                  availableForSale
                  priceRange {
                    minVariantPrice {
                      amount
                    }
                    maxVariantPrice {
                      amount
                    }
                  }
                  compareAtPriceRange {
                    maxVariantPrice {
                      amount
                    }
                    minVariantPrice {
                      amount
                    }
                  }
                  featuredImage {
                    src
                    altText
                    height
                    width
                  }
                  metafields(
                    identifiers: [{key: "custom", namespace: "delivery_time"}, {key: "custom", namespace: "tech_andaz_product_min_limit"}, {key: "custom", namespace: "tech_andaz_product_max_limit"}]
                  ) {
                    key
                    value
                  }
                  onlineStoreUrl
                  variantsCount {
                    count
                  }
                  variants(first: 250) {
                    nodes {
                      storeAvailability(near: $nearLat, first: 250) {
                        nodes {
                          available
                          quantityAvailable
                          location {
                            id
                          }
                        }
                      }
                      id
                      title
                      availableForSale
                      priceV2 {
                        amount
                      }
                      compareAtPriceV2 {
                        amount
                      }
                    }
                  }
                }
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
          }
      `;
      const settings = {
        variables: {
          searchTerm: searchTerm,
          filters: queryFilters.filters,
          reverse: queryFilters.reverse,
          sortKey: "RELEVANCE",
          afterCursor: cursor || null,
          nearLat: {
            latitude: selectedStoreLat,
            longitude: selectedStoreLong
          }
        },
      };
      const {data, errors, extensions} = await shopifyClient.request(productQuery, settings);
      if (errors) {
        handleErrors(errors);
        return;
      }
      var collectionProducts = data.search.nodes;
      var pageInfo = data.search.pageInfo;
      var products = [];
      outer: for(var i = 0; i < collectionProducts.length; i++){
        var product_availability = 0;
        if(collectionProducts[i].availableForSale == true){
          var variants = collectionProducts[i].variants.nodes;
          var organizedVariants = [];
          variantInner: for(var j = 0; j < variants.length; j++){
            var storeQuantity = 0;
            if(variants[j].availableForSale == true){
              var storeAvaiabilities = variants[j].storeAvailability.nodes;
              for(var k = 0; k < storeAvaiabilities.length; k++){
                if(storeAvaiabilities[k].location.id == selected_store_location && storeAvaiabilities[k].available == true){
                  collectionProducts[i].variants.nodes[j].storeAvailability = storeAvaiabilities[k].quantityAvailable;
                  product_availability = 1;
                  continue variantInner;
                }
              }
              collectionProducts[i].variants.nodes[j].storeAvailability = 0;
            }
          }
        }
        if(product_availability == 1){
          products.push(collectionProducts[i]);
        }
      }
      resolve({products: products, pageInfo: pageInfo});
    });
}

//Address & Store Selector
function createSelectedLocationMap (selector, latitude, longitude) {
  if(selector == 'pickup_map') {
      pickup_map_marker.setLatLng([latitude,longitude]);
      pickup_map.setView([latitude,longitude]);
  } else if(selector == 'delivery_map') {
      delivery_map_marker.setLatLng([latitude,longitude]);
      delivery_map.setView([latitude,longitude]);
  }
}

//PICKUP
function convertCartAttributes(cartAttributesArray) {
  return cartAttributesArray.reduce((obj, item) => {
    obj[item.key] = item.value;
    return obj;
  }, {});
}
$(document).on("click", "#offcanvasPickup .store-choose-btn", async function() {
    var store = $("#offcanvasPickup .store-card.active");
    if(store.length == 0) {
        Notiflix.Notify.failure('You must select a store first first!');
        return;
    } 
    Notiflix.Loading.standard('Please wait...');
    var store_id = store.attr('store_id');
    var currentStoreID = getCookie('tech_andaz_store_id');
    if(currentStoreID != "" && currentStoreID != undefined && currentStoreID != null){
        currentStoreID = getCookie('tech_andaz_store_id').toString();
    }
    var newStoreID = store_id;
    if(currentStoreID != newStoreID){
      await createCart();
      if(customerCart.lines.length > 0){
          Notiflix.Confirm.show(
          'Change Stores?',
          'Changing stores will empty your cart. Are you sure you want to continue?',
          'Yes',
          'No',
          async () => {
              Notiflix.Loading.standard('Please wait...');
              await removeAllCartItems();
              await updateCartPickupLocation(newStoreID);
              Notiflix.Loading.remove();
          },
          async () => {
              $("#addPickupCanvasButton").removeAttr("disabled");
              Notiflix.Loading.remove();
          },
          );
      } else {
          await updateCartPickupLocation(newStoreID);
      }      
    } else {             
      await updateCartPickupLocation(newStoreID);  
    }
});
function updateCartPickupLocation(store_id){
  return new Promise(async (resolve,reject) => {
      var store_name = "";
      var store = {};
      for(var i = 0; i < all_store_locations.locations.length; i++){
        if(all_store_locations.locations[i].location_id == store_id){
          store_name = all_store_locations.locations[i].location_name;
          store = all_store_locations.locations[i];
          break;
        }
      }
      if(store_name == ""){
        Notiflix.Notify.failure('Unable to set pickup location!');
        resolve();
      }
      var cartAttributes = [
        {
            key: "latitude", 
            value: store.lat.toString()
        },
        {
            key: "longitude", 
            value: store.long.toString()
        },
        {
            key: "location_id", 
            value: store_id.toString()
        },
        {
            key: "location_name", 
            value: store_name.toString()
        },
        {
            key: "default_location", 
            value: store.is_default.toString()
        },
        {
            key:"order_method",
            value: "pickup"
        }
    ];
    var attr = await addUpdateCartAttribute(cartAttributes);
    if(attr.userErrors.length > 0){
      handleErrors(attr.userErrors);
      return;
    }
    setCookie('tech_andaz_store_id', store_id.toString(), 1);
    setCookie('tech_andaz_store_lat', store.lat.toString(), 1);
    setCookie('tech_andaz_store_long', store.long.toString(), 1);
    await createCart();

    const attributes = convertCartAttributes(cartAttributes);
    const data = {
      attributes: attributes
    };
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (!response.ok) {
        Notiflix.Notify.failure('Unable to set pickup location!');
        resolve();
      }
      return response.json();
    })
    .then(data => {
      window.location.reload();
      resolve();
    })
    .catch(error => {
      Notiflix.Notify.failure('Unable to set pickup location!');
      resolve();
    });
  });
}

//Delivery
async function updateSavedAddresses(addresses){
  return new Promise(async (resolve,reject) => {
    var address_list = "";
    if(!addresses){
      addresses = [];
    }
    for(var i = 0; i < addresses.length; i++){
      var to_show = 1;
      var address_type = 'outofcity';
      for(var j = 0; j < delivery_cities.length; j++){
        if(delivery_cities[j].city.toLowerCase() == addresses[i].city.toLowerCase()){
          if(delivery_cities[j].map_available == true && (!addresses[i].latitude || !addresses[i].longitude || !addresses[i].google_address)){
            to_show = 0;
          }
          if(delivery_cities[j].map_available == true){
            address_type = 'mapbased';
          }
        }
      }
      if(to_show == 1){
        var address_all_parts = [addresses[i].first_name + " " + addresses[i].last_name, addresses[i].address1];
        if(addresses[i].address2 != "" && addresses[i].address2 != null && addresses[i].address2 != undefined){
          address_all_parts.push(addresses[i].address2);
        }
        if(addresses[i].area != "" && addresses[i].area != null && addresses[i].area != undefined){
          address_all_parts.push(addresses[i].area);
        }
        if(addresses[i].city != "" && addresses[i].city != null && addresses[i].city != undefined){
          address_all_parts.push(addresses[i].city);
        }
        if(addresses[i].country != "" && addresses[i].country != null && addresses[i].country != undefined){
          address_all_parts.push(addresses[i].country);
        }
        var full_address = address_all_parts.join(", ");
        address_list += `<li id="` + addresses[i].id + `" address_type = "` + address_type + `">` + full_address + `</li>`;
      }
    }
    if(address_list!='') {
      $("#customer_saved_address_list").html(address_list);
    } else {
      $("#customer_saved_address_list").html('<div style="text-align: center;margin-top: 12px;margin-bottom: 15px;font-size: 17px;color: #b50606;">No Saved Addresses Found</div>');
    }
    resolve();
  });
}
$(document).on("click", "#customer-address-selection .existing-address-btn", async function() {
  var existing_address = $("#customer-address-selection .saved-address li.active");
  if(existing_address.length == 0) {
      Notiflix.Notify.failure('Please select the address from the given list');
      return;
  } 
  Notiflix.Loading.standard('Please wait...');
  var selected_address_id = existing_address.attr('id');
  var address_type = existing_address.attr('address_type');
  var userAddress;
  for(var i = 0; i < customerSavedAddresses.length; i++){
    if(customerSavedAddresses[i].id == selected_address_id){
      var userAddress = customerSavedAddresses[i];
      break;
    }
  }
  if(!userAddress){
    Notiflix.Loading.remove();
    Notiflix.Notify.failure('Unable to get the selected address details');
    return;
  }
  var store;
  if(address_type == 'mapbased'){
    var deliveryStore = await getDeliveryZone([userAddress.latitude, userAddress.longitude]);
    var expressStore = await getDeliveryZoneExpress([userAddress.latitude, userAddress.longitude]);
    if(deliveryStore && expressStore){
      Notiflix.Confirm.show(
          'Choose Store Type',
          `<div style="">
              <p>Select a store type to continue:</p>
              <p>📦 <strong>QuickShop:</strong> Available Near You, Fast delivery, Limited stock.</p>
              <p>🏬 <strong>Full Access:</strong> Shop All Stores in One Go. Standard Delivery</p>
          </div>`,
         'QuickShop',
          'Full Access',
          async () => {
              Notiflix.Loading.standard('Please wait...');
              store = expressStore;
              await setDeliveryStore(store, userAddress);
              Notiflix.Loading.remove();
          },
          async () => {
              Notiflix.Loading.standard('Please wait...');
              store = deliveryStore;
              await setDeliveryStore(store, userAddress);
              Notiflix.Loading.remove();
          },
          {
            plainText: false,
            width: '500px',
            borderRadius: '8px',
            messageMaxLength: 2000
          }
      );
    } else {
      store = deliveryStore;
      await setDeliveryStore(store, userAddress);
    }
  } else {
    for(var j = 0; j < all_store_locations.locations.length; j++){
      if(all_store_locations.locations[j].is_default == "1"){
        store = {
          location_id: all_store_locations.locations[j].location_id,
          location_name: all_store_locations.locations[j].location_name,
          is_default: all_store_locations.locations[j].is_default
        };
      }
    }
    if(!store){
      Notiflix.Notify.failure('Unable to get the selected address store details');
      Notiflix.Loading.remove();
      return;
    }
    await setDeliveryStore(store, userAddress);
    Notiflix.Loading.remove();
  }
});
$(document).on("click", ".address-choose-btn", async function() {
    Notiflix.Loading.standard('Please wait...');
    var userAddress= {
        first_name: $("#first_name").val(),
        last_name: $("#last_name").val(),
        phone: $("#phone").val(),
        area: $("#area").val(),
        city: $("#city").val(),
        address1: $("#street_address_1").val(),
        address2: $("#street_address_2").val(),
        latitude: '',
        longitude: '',
        google_address: ''
    };
    if(!userAddress.first_name || !userAddress.last_name || !userAddress.phone || !userAddress.city || !userAddress.area || !userAddress.address1 || !userAddress.address2) {
        Notiflix.Notify.failure('Please fill all the address fields');
        Notiflix.Loading.remove();
        return;
    }
    var map_available = $('#city option:selected').data('map-available');
    if(map_available == false) {
      for(var j = 0; j < all_store_locations.locations.length; j++){
        if(all_store_locations.locations[j].is_default == "1"){
          store = {
            location_id: all_store_locations.locations[j].location_id,
            location_name: all_store_locations.locations[j].location_name,
            is_default: all_store_locations.locations[j].is_default
          };
        }
      }
      if(!store){
        Notiflix.Notify.failure('Unable to get the selected address store details');
        Notiflix.Loading.remove();
        return;
      }
      await saveCustomerAddress(userAddress);
      await setDeliveryStore(store, userAddress);
    } else {
        var address_all_parts = [userAddress.address1];
        if(userAddress.address2 != "" && userAddress.address2 != null && userAddress.address2 != undefined){
          address_all_parts.push(userAddress.address2);
        }
        if(userAddress.area != "" && userAddress.area != null && userAddress.area != undefined){
          address_all_parts.push(userAddress.area);
        }
        if(userAddress.city != "" && userAddress.city != null && userAddress.city != undefined){
          address_all_parts.push(userAddress.city);
        }
        var full_address = address_all_parts.join(", ");
        //var addressSearch = await getAddressLatLongs(full_address, default_latitude, default_longitude);
        $('#offcanvasDelivery').offcanvas('hide');
        $("#customer-address-map-selection").modal('show');
        setTimeout(function(){ 
            customer_delivery_map.invalidateSize();
            $(".locate_me_map_button").click();
            customer_delivery_map.invalidateSize();
            // customer_delivery_map.setView([addressSearch.latitude, addressSearch.longitude], 16);
            // customer_delivery_map_marker.setLatLng([addressSearch.latitude, addressSearch.longitude]);
        }, 500); 
    }
    Notiflix.Loading.remove();
});
async function saveCustomerAddress(userAddress){
  return new Promise(async (resolve,reject) => {
    var customerAccessTokenCheck = localStorage.getItem('customer_access_token')
    if(customerAccessTokenCheck != null && customerAccessTokenCheck != "" && customerAccessTokenCheck != undefined){
      var customerInfo = await getCustomer();
      var customerAddresses = customerInfo.addresses;
      customerAddresses.push(
        {
          "id": new Date().getTime(),
          "first_name": userAddress?.first_name ?? "",
          "last_name": userAddress?.last_name ?? "",
          "phone": userAddress?.phone ?? "",
          "address1": userAddress?.address1 ?? "",
          "address2": userAddress?.address2 ?? "",
          "city": userAddress?.city ?? "",
          "country": "Pakistan",
          "area": userAddress?.area ?? "",
          "google_address": userAddress?.google_address ?? "",
          "latitude": userAddress?.latitude ?? "",
          "longitude": userAddress?.longitude ?? ""
        }
      );

      const response = await fetch('https://shopify.com/' + shopify_customer_shop_id + '/account/customer/api/2026-01/graphql',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: customerAccessTokenCheck,
          },
          body: JSON.stringify({
            query: `
              mutation setCustomerMeta($metafields: [MetafieldsSetInput!]!) {
                metafieldsSet(metafields: $metafields) {
                  metafields {
                    key
                    namespace
                    value
                    type
                  }
                  userErrors {
                    field
                    message
                  }
                }
              }
            `,
            variables: {
              metafields: [
                {
                  namespace: "custom",
                  key: "addresses",
                  type: "json",
                  ownerId: customerInfo.id,
                  value: JSON.stringify(customerAddresses),
                }
              ]
            }
          }),
        }
      );
      const result = await response.json();
      resolve(1);
    }
    resolve();
  });
}
async function setDeliveryStore(store, userAddress){
  return new Promise(async (resolve,reject) => {
    var currentStoreID = getCookie('tech_andaz_store_id');
    if(currentStoreID != "" && currentStoreID != undefined && currentStoreID != null){
      currentStoreID = getCookie('tech_andaz_store_id').toString();
    }
    var newStoreID = store.location_id.toString();
    if(currentStoreID != newStoreID){
      await createCart();
      if(customerCart.lines.length > 0){
        Notiflix.Confirm.show(
          'Change Stores?',
          'Changing locations will empty your cart. Are you sure you want to continue?',
          'Yes',
          'No',
          async () => {
            Notiflix.Loading.standard('Please wait...');
            await removeAllCartItems();
            await updateCartWithLocation(store, userAddress);      
            Notiflix.Loading.remove();
            resolve(1);
          },
          async () => {
            await updateCartWithLocation(store, userAddress); 
            $("#offcanvasPickup .store-choose-btn").html('CHOOSE STORE'); 
            Notiflix.Loading.remove();
            resolve(1);
          },
        );
      } else {
        await updateCartWithLocation(store, userAddress);  
        Notiflix.Loading.remove();
        resolve(1);
      }      
    } else {
      await updateCartWithLocation(store, userAddress); 
      Notiflix.Loading.remove();
      resolve(1);
    }
  });
}
function updateCartWithLocation(store, userAddress){
  return new Promise(async (resolve,reject) => {
    userAddress.global_map_available = true;
    if(userAddress.google_address == undefined) {
      userAddress.google_address = '';
      userAddress.global_map_available = false;
    }
    if(store.is_default == undefined || store.is_default != "0") {
      userAddress.global_map_available = false;
    }
    var cartAttributes = [
        {
            key: "first_name", 
            value: userAddress.first_name.toString()
        },
        {
            key: "last_name", 
            value: userAddress.last_name.toString()
        },
        {
            key: "phone", 
            value: userAddress.phone.toString()
        },
        {
            key: "area", 
            value: userAddress.area.toString()
        },
        {
            key: "city", 
            value: userAddress.city.toString()
        },
        {
            key: "address2", 
            value: userAddress.address2.toString()
        },
        {
            key: "address1", 
            value: userAddress.address1.toString()
        },
        {
            key: "latitude", 
            value: userAddress.latitude.toString()
        },
        {
            key: "longitude", 
            value: userAddress.longitude.toString()
        },
        {
            key: "google_address", 
            value: userAddress.google_address.toString()
        },
        {
            key: "global_map_available", 
            value: userAddress.global_map_available.toString()
        },
        {
            key: "location_id", 
            value: store.location_id.toString()
        },
        {
            key: "location_name", 
            value: store.location_name.toString()
        },
        {
            key: "default_location", 
            value: store.is_default.toString()
        },
        {
            key:"order_method",
            value: "delivery"
        }
    ];
    // cartAttributes = cartAttributes.filter(attr => attr.value !== null && attr.value !== undefined && attr.value !== '');
    var attr = await addUpdateCartAttribute(cartAttributes);
    if(attr.userErrors.length > 0){
      handleErrors(attr.userErrors);
      return;
    }
    setCookie('tech_andaz_store_id', store.location_id.toString(), 1);
    for(var j = 0; j < all_store_locations.locations.length; j++){
      if(all_store_locations.locations[j].location_id == store.location_id){
        setCookie('tech_andaz_store_lat', all_store_locations.locations[j].lat.toString(), 1);
        setCookie('tech_andaz_store_long', all_store_locations.locations[j].long.toString(), 1);
        break;
      }
    }
    await createCart();
    const attributes = convertCartAttributes(cartAttributes);
    const data = {
      attributes: attributes
    };
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (!response.ok) {
        Notiflix.Notify.failure('Unable to set delivery location!');
        resolve();
      }
      return response.json();
    })
    .then(data => {
      window.location.reload();
      resolve();
    })
    .catch(error => {
      Notiflix.Notify.failure('Unable to set delivery location!');
      resolve();
    });     
  });  
}
function getDeliveryZone(userCoordinates) {
  return new Promise(async function(resolve, reject){
    var deliveryZones = [];
    for (var i  = 0; i < all_store_locations.locations.length; i++){
      if(all_store_locations.locations[i].express != "1"){
        deliveryZones.push(all_store_locations.locations[i]);
      }
    }
    for (let i = 0; i < deliveryZones.length; i++) {
        if(deliveryZones[i].delivery_type == "Delivery Zones"){
          if (await isPointInPolygon(userCoordinates, JSON.parse(deliveryZones[i].coordinates))) {
              default_location = 0;
              resolve(deliveryZones[i]);
          }
        }
    }
    var locations_in_radius = [];
    for (let i = 0; i < deliveryZones.length; i++) {
        if(deliveryZones[i].delivery_type == "Radius"){
          if (isWithinRadius(userCoordinates[0], userCoordinates[1], deliveryZones[i].lat, deliveryZones[i].long, parseFloat(deliveryZones[i].radius))) {
              locations_in_radius.push(deliveryZones[i]);
          }
        }
    }
    if (locations_in_radius.length > 0) {
        default_location = 0;
        resolve(await findClosestCoordinate(userCoordinates[0], userCoordinates[1], locations_in_radius));
    } else {
        for (let i = 0; i < deliveryZones.length; i++) {
            if(deliveryZones[i].is_default == 1){
                default_location = 1;
                resolve(deliveryZones[i]);
            }
        }
    }
    for(var j = 0; j < all_store_locations.locations.length; j++){
      if(all_store_locations.locations[j].is_default == "1"){
        resolve(all_store_locations.locations[j]);
      }
    }
  });
}
async function checkIfExpressStillAvailable(){
	return new Promise(async (resolve, reject) => {
      var current_location = null;
    outer: for(var i = 0; i < customerCart.attributes.length; i++){
      if(customerCart.attributes[i].key == "location_id" && customerCart.attributes[i].value != "" && customerCart.attributes[i].value != undefined && customerCart.attributes[i].value != null){
        for(var j = 0; j < all_store_locations.locations.length; j++){
          if(all_store_locations.locations[j].location_id == customerCart.attributes[i].value){
            current_location = all_store_locations.locations[j];
            break outer;
          }
        }
      }
    }
    if(current_location == 0){
      await getCart();
      outer: for(var i = 0; i < customerCart.attributes.length; i++){
        if(customerCart.attributes[i].key == "location_id" && customerCart.attributes[i].value != "" && customerCart.attributes[i].value != undefined && customerCart.attributes[i].value != null){
          for(var j = 0; j < all_store_locations.locations.length; j++){
            if(all_store_locations.locations[j].location_id == customerCart.attributes[i].value){
              current_location = all_store_locations.locations[j];
              break outer;
            }
          }
        }
      }
    }
    if(current_location == null){
      resolve(true);
    }
    if(current_location.express == 1 || current_location.express == "1" ){
      if(isNowInKarachiBetween(current_location.express_start_time, current_location.express_end_time)){
        resolve(true);
      }
      resolve(false);
    }
    resolve(true);
  });
  
}
function isNowInKarachiBetween(startTime, endTime) {
  const now = new Date();
  const karachiDate = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Karachi",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);

  const start = new Date(`${karachiDate}T${startTime}`);
  let end = new Date(`${karachiDate}T${endTime}`);
  const karachiNow = new Date(
    now.toLocaleString("en-US", { timeZone: "Asia/Karachi" })
  );
  if (end < start) {
    end.setDate(end.getDate() + 1);
  }
  return karachiNow >= start && karachiNow <= end;
}
function getDeliveryZoneExpress(userCoordinates) {
  return new Promise(async function(resolve, reject){
    var deliveryZones = [];
    for (var i  = 0; i < all_store_locations.locations.length; i++){
      if(all_store_locations.locations[i].express == "1" || all_store_locations.locations[i].express == 1){
        if(isNowInKarachiBetween(all_store_locations.locations[i].express_start_time, all_store_locations.locations[i].express_end_time)){
          deliveryZones.push(all_store_locations.locations[i]);
        }
      }
    }
    for (let i = 0; i < deliveryZones.length; i++) {
        if(deliveryZones[i].delivery_type == "Delivery Zones"){
          if (await isPointInPolygon(userCoordinates, JSON.parse(deliveryZones[i].coordinates))) {
              default_location = 0;
              resolve(deliveryZones[i]);
          }
        }
    }
    var locations_in_radius = [];
    for (let i = 0; i < deliveryZones.length; i++) {
        if(deliveryZones[i].delivery_type == "Radius"){
          if (isWithinRadius(userCoordinates[0], userCoordinates[1], deliveryZones[i].lat, deliveryZones[i].long, parseFloat(deliveryZones[i].radius))) {
              locations_in_radius.push(deliveryZones[i]);
          }
        }
    }
    if (locations_in_radius.length > 0) {
        default_location = 0;
        resolve(await findClosestCoordinate(userCoordinates[0], userCoordinates[1], locations_in_radius));
    } else {
        for (let i = 0; i < deliveryZones.length; i++) {
            if(deliveryZones[i].is_default == 1){
                default_location = 1;
                resolve(deliveryZones[i]);
            }
        }
    }
    resolve();
  });
}
function isPointInPolygon(point, polygon) {
    return new Promise(function(resolve, reject){
        const x = point[1];
        const y = point[0];
        let isInside = false;
        for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            const xi = polygon[i][1];
            const yi = polygon[i][0];
            const xj = polygon[j][1];
            const yj = polygon[j][0];

            const intersect =
            yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
            if (intersect) isInside = !isInside;
        }
        resolve(isInside);
    });
}
function findClosestCoordinate(userLat, userLng, coordinates) {
    return new Promise(function(resolve, reject){
      let closestCoordinate;
      let closestDistance = Number.MAX_VALUE;
      coordinates.forEach((coordinate) => {
        const {lat, long} = coordinate;
        const distance = calculateDistance(userLat, userLng, lat, long);
        if (distance < closestDistance) {
          closestCoordinate = coordinate;
          closestDistance = distance;
        }
      });
      resolve(closestCoordinate);
    });
    
}
function calculateDistance(lat1, lng1, lat2, lng2) {
    const radLat1 = (Math.PI / 180) * lat1;
    const radLng1 = (Math.PI / 180) * lng1;
    const radLat2 = (Math.PI / 180) * lat2;
    const radLng2 = (Math.PI / 180) * lng2;
    const earthRadius = 6371;
    const diffLat = radLat2 - radLat1;
    const diffLng = radLng2 - radLng1;
    const a = Math.sin(diffLat / 2) * Math.sin(diffLat / 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.sin(diffLng / 2) * Math.sin(diffLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadius * c;

    return distance;
}
function isWithinRadius(lat1, lng1, lat2, lng2, radius) {
    const radLat1 = (Math.PI / 180) * lat1;
    const radLng1 = (Math.PI / 180) * lng1;
    const radLat2 = (Math.PI / 180) * lat2;
    const radLng2 = (Math.PI / 180) * lng2;
    const earthRadius = 6371;
    const diffLat = radLat2 - radLat1;
    const diffLng = radLng2 - radLng1;
    const a = Math.sin(diffLat / 2) * Math.sin(diffLat / 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.sin(diffLng / 2) * Math.sin(diffLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadius * c;
    return distance <= radius;
}
function getAddressLatLongs(address, latitude, longitude){
  return new Promise(async (resolve,reject) => {
    const params = new URLSearchParams({
      name: address,
      output: "lat,lng,compound_address_parents",
      apikey: tpl_api_key
    });

    fetch(`https://api1.tplmaps.com:8888/search?${params.toString()}`)
      .then(res => res.json())
      .then(data => {
        if (data && data.length > 0) {
          resolve({
            latitude: data[0].lat,
            longitude: data[0].lng
          });
        } else {
          resolve({ latitude, longitude });
        }
      })
      .catch(err => {
        resolve({ latitude, longitude });
      });
  });
}
function tplReverseGeoCode(latitude, longitude) {
  return new Promise(async (resolve) => {
    const params = new URLSearchParams({
      point: latitude + ";" + longitude,
      output: "name,parent,parent1,parent2,parent3,country,lat,lng,subcat_name,cat_name,cpd_address",
      apikey: tpl_api_key,
    });

    try {
      const res = await fetch(`https://api1.tplmaps.com:8888/search/point?${params.toString()}`);
      const response = await res.json();

      if (response && response.data && response.data.length > 0 && response.data[0].cpd_address) {
        const d = response.data[0];

        const formatted_address = d.cpd_address
          .replace(new RegExp(d.parent3, 'g'), '')
          .replace(new RegExp(d.parent2, 'g'), '')
          .replace(/[,\s]+$/, '');

        resolve({
          status: 1,
          neighborhood: d.parent,
          city: d.parent2,
          area: d.parent1,
          state: d.parent3,
          address: formatted_address,
          google_address: d.cpd_address,
        });

      } else {
        resolve({
          status: 0,
          neighborhood: "",
          city: "",
          area: "",
          state: "",
          address: "",
          google_address: "",
        });
      }

    } catch (e) {
      resolve({
        status: 0,
        neighborhood: "",
        city: "",
        area: "",
        state: "",
        address: "",
        google_address: "",
      });
    }
  });
}
$(document).on("click",".confirm_location_button",function (){
    Notiflix.Loading.standard('Please wait...');
    var current_location = customer_delivery_map.getCenter();       
    if(current_location.lat == default_latitude && current_location.lng == default_longitude) {
        Notiflix.Notify.failure('Please move the marker to your delivery address');
        Notiflix.Loading.remove();
        return;       
    }
    tplReverseGeoCode(current_location.lat, current_location.lng).then(async function(res){
        if (res.address.endsWith(',')) {
            res.address = res.address.slice(0, -1);
        }
        var userAddress= {
            first_name: $("#first_name").val(),
            last_name: $("#last_name").val(),
            phone: $("#phone").val(),
            area: $("#area").val(),
            city: $("#city").val(),
            address1: $("#street_address_1").val(),
            address2: $("#street_address_2").val(),
            latitude: current_location.lat,
            longitude: current_location.lng,
            google_address: res.address
        };
        await saveCustomerAddress(userAddress);
        var deliveryStore = await getDeliveryZone([current_location.lat, current_location.lng]);
        var expressStore = await getDeliveryZoneExpress([current_location.lat, current_location.lng]);
        if(deliveryStore && expressStore){
          Notiflix.Confirm.show(
              'Choose Store Type',
              `<div style="">
                  <p>Select a store type to continue:</p>
                  <p>📦 <strong>Express Store:</strong> Fast delivery, limited stock.</p>
                  <p>🏬 <strong>Normal Store:</strong> Standard delivery, full stock.</p>
              </div>`,
            'Express Store',
              'Normal Store',
              async () => {
                  Notiflix.Loading.standard('Please wait...');
                  store = expressStore;
                  await setDeliveryStore(store, userAddress);
                  Notiflix.Loading.remove();
              },
              async () => {
                  Notiflix.Loading.standard('Please wait...');
                  store = deliveryStore;
                  await setDeliveryStore(store, userAddress);
                  Notiflix.Loading.remove();
              },
              {
                plainText: false,
                width: '500px',
                borderRadius: '8px',
                messageMaxLength: 2000
              }
          );
        } else {
          store = deliveryStore;
          await setDeliveryStore(store, userAddress);
        }
    }).catch(function(err){
        Notiflix.Notify.failure('There was an error fetching your location!');
        Notiflix.Loading.remove();
        return;       
    });
});

var lastSearchTerm = "";
var searchRequest;
let searchController = null;
$(document).on("keyup","#search_input_bar", function(){
    var searchTerm = $(this).val().trim();
    if(searchTerm == '') {
        $(".tpl-search-results ul").html('');
        $(".tpl-search-results").hide();
        lastSearchTerm = searchTerm;
    }
});
$(document).on("click", ".search_input_bar_button", function () {
  var searchTerm = $("#search_input_bar").val().trim();
  if (searchTerm !== lastSearchTerm) {
    if (searchController) {
      searchController.abort();
    }
    lastSearchTerm = searchTerm;
    if (searchTerm !== "") {
      if (searchTerm !== $("#search_input_bar").val().trim()) {
        return false;
      }
      $(".search_input_bar_button").html('<i class="bi bi-arrow-repeat spinner-icon"></i>');
      searchController = new AbortController();
      const signal = searchController.signal;
      const params = new URLSearchParams({
        name: searchTerm,
        output: "name,parent,parent1,parent2,parent3,country,lat,lng,cpd_address",
        apikey: tpl_api_key,
        location: second_latitude + ";" + second_longitude,
      });

      fetch(`https://api1.tplmaps.com:8888/search/optimizedSearch?${params.toString()}`, {
        method: "GET",
        signal,
      })
        .then((res) => res.json())
        .then((response) => {
          $(".search_input_bar_button").html('<i class="bi bi-search"></i>');

          if (response && response.data && response.data.length > 0) {
            $(".tpl-search-results").show();

            let searchResult = "";
            for (let i = 0; i < response.data.length; i++) {
              searchResult += `
                <li latitude="${response.data[i].lat}" longitude="${response.data[i].lng}">
                  ${response.data[i].cpd_address}
                </li>`;
            }

            $(".tpl-search-results ul").html(searchResult);
          } else {
            $(".tpl-search-results ul").html("");
            $(".tpl-search-results").hide();
          }
        })
        .catch((error) => {
          $(".search_input_bar_button").html('<i class="bi bi-search"></i>');
          if (error.name === "AbortError") return;
          console.error(error);
        });
    }
  }
});
function removeAllCartItems(){
  return new Promise(async (resolve,reject) => {
      await createCart();
      var variant_ids = [];
      for(var i = 0; i < customerCart.lines.length; i++){
        variant_ids.push(customerCart.lines[i].id);
      }
      if(variant_ids.length > 0){
        var chunkedArrays = chunkArray(variant_ids,250);
        for(var i = 0; i < chunkedArrays.length; i++){
          await cartLinesRemove(chunkedArrays[i]);
        };
      }
      resolve(1);
  });
}
$(document).on("click", ".pickup-store-change", function() {
    $(".pickup-order .order-type-box-info").show();
    $(".delivery-order .order-type-box-info").show();
    $(".order-type-box-pickup").addClass("changeRequested");
    $(".order-type-box-pickup").hide();
});
$(document).on("click", ".delivery-store-change", function() {
    $(".pickup-order .order-type-box-info").show();
    $(".delivery-order .order-type-box-info").show();
    $(".order-type-box-delivery").addClass("changeRequested");
    $(".order-type-box-delivery").hide();
});

//Front End
function initiateProductSliders(){
  var elements = $(".render_product_cards");
  for(var i = 0; i < elements.length; i++){
    processProductPopulation({
      collection_id: $(elements[i]).attr('collection_id'),
      section_id: $(elements[i]).attr('section_id'),
      display_type: $(elements[i]).attr('display_type'),
      is_search: $(elements[i]).attr('is_search'),
      search_term: $(elements[i]).attr('search_term'),
      number_of_products: $(elements[i]).attr('number_of_products'),
      no_of_columns_desktop: $(elements[i]).attr('no_of_columns_desktop'),
      no_of_columns_tablet: $(elements[i]).attr('no_of_columns_tablet'),
      no_of_columns_mobile: $(elements[i]).attr('no_of_columns_mobile'),
      related_products: $(elements[i]).attr('related_products'),
      related_by: $(elements[i]).attr('related_by'),
      intent: $(elements[i]).attr('intent'),
      product_id: $(elements[i]).attr('product_id'),
      pagination: $(elements[i]).attr('pagination'),
      cursor: $(elements[i]).attr('cursor'),
      haspagenext: $(elements[i]).attr('haspagenext'),
      this_element: $(elements[i])
    });
  }
}
function initiatePaginationSlider(section_id){
  var section = $(".render_product_cards[section_id='" + section_id + "']");   
  processProductPopulation({
    collection_id: $(section).attr('collection_id'),
    section_id: $(section).attr('section_id'),
    is_search: $(section).attr('is_search'),
    search_term: $(section).attr('search_term'),
    display_type: $(section).attr('display_type'),
    number_of_products: $(section).attr('number_of_products'),
    no_of_columns_desktop: $(section).attr('no_of_columns_desktop'),
    no_of_columns_tablet: $(section).attr('no_of_columns_tablet'),
    no_of_columns_mobile: $(section).attr('no_of_columns_mobile'),
    related_products: $(section).attr('related_products'),
    related_by: $(section).attr('related_by'),
    intent: $(section).attr('intent'),
    product_id: $(section).attr('product_id'),
    pagination: $(section).attr('pagination'),
    cursor: $(section).attr('cursor'),
    haspagenext: $(section).attr('haspagenext'),
    this_element: $(section)
  });
}
function processProductPopulation(settings){
  return new Promise(async function(resolve, reject){
    if(settings.related_products){
      var collection_response;
      var relatedBy = (settings.related_by || '').toString().toUpperCase();
      if(relatedBy === 'CATEGORY'){
        collection_response = await getRelatedByCategoryProducts(settings.product_id);
        // fallback to normal recommendations if category returns nothing
        if(!collection_response || !collection_response.products || collection_response.products.length === 0){
          collection_response = await getRecommendedProducts(settings.product_id, settings.intent);
        }
      } else {
        collection_response = await getRecommendedProducts(settings.product_id, settings.intent);
      }
    } else {
      if(settings.is_search){
        if(settings.pagination == "1" && settings.cursor != ""){
          var collection_response = await searchProducts(settings.search_term, settings.cursor);
        } else {
          var collection_response = await searchProducts(settings.search_term);
        }
      } else {
        if(settings.pagination == "1" && settings.cursor != ""){
          var collection_response = await getCollectionProducts(settings.collection_id, settings.cursor);
        } else {
          var collection_response = await getCollectionProducts(settings.collection_id);
        }
      }
      
      if(settings.pagination == "1"){
        settings.this_element.attr("cursor", collection_response.pageInfo.endCursor);
        settings.this_element.attr("haspagenext", collection_response.pageInfo.hasNextPage);
      }
    }
    var products = collection_response.products;
    
    var product_cards = [];
    var max_length = settings.number_of_products;
    if(products.length < max_length){
      max_length = products.length;
    }
    for(var i = 0; i < max_length; i++){
      var product = products[i];
      var html_element = $(productCardTemplate);
      if(product.featuredImage == null || product.featuredImage == "" || product.featuredImage.src == null || product.featuredImage.src == ""){
        html_element.find('.product_image').attr("src", no_product_image_url);
        html_element.find('.product_image').attr("alt", "Al-Fatah Product");
      } else {
        html_element.find('.product_image').attr("src", product.featuredImage.src);
        html_element.find('.product_image').attr("alt", product.featuredImage.altText);
      }
      html_element.find('.product_title').html(product.title);
      if(product.variantsCount.count > 1){
        //Multi Variant Product
        var salePriceMin = product.priceRange.minVariantPrice.amount;
        var salePriceMax = product.priceRange.maxVariantPrice.amount;
        var comparePriceMin = product.compareAtPriceRange.minVariantPrice.amount;
        var comparePriceMax = product.compareAtPriceRange.maxVariantPrice.amount;
        html_element.find('.product_compare_price').remove();
        if(salePriceMin == salePriceMax){
          html_element.find('.product_sale_price').html(formatPrice(salePriceMax));
        } else {
          html_element.find('.product_sale_price').html(formatPrice(salePriceMin) + " - " + formatPrice(salePriceMax));
        }
        if(comparePriceMin > salePriceMin || comparePriceMax > salePriceMax){
          html_element.find('.sale_badge').css("display", "block");
          html_element.find('.sale_badge').html("ON SALE");
        } else {
          html_element.find('.sale_badge').css("display", "none");
        }
        html_element.find('.custom-add-to-cart-btn').remove();
        html_element.find('.custom-view-options-btn').show();
      } else { 
        //Single Variant Product
        var compareAtPrice = product.compareAtPriceRange.minVariantPrice.amount;
        var salePrice = product.priceRange.minVariantPrice.amount;
        html_element.find('.product_sale_price').html(formatPrice(salePrice));
        if(compareAtPrice > salePrice){
          html_element.find('.product_compare_price').html(formatPrice(compareAtPrice));
          html_element.find('.sale_badge').css("display", "block");
          html_element.find('.sale_badge').html(Math.round(((compareAtPrice - salePrice) / compareAtPrice) * 100) + "% OFF");
        } else {
          html_element.find('.product_compare_price').remove();
          html_element.find('.sale_badge').css("display", "none");
        }
        html_element.find('.custom-view-options-btn').remove();
        html_element.find('.custom-add-to-cart-btn').show();
        html_element.find('.custom-add-to-cart-btn').attr("variant_id", product.variants.nodes[0].id);
        html_element.find('.custom-quantity-btn').attr("variant_id", product.variants.nodes[0].id);
        html_element.find('.product_card_quantity_selector').attr("variant_id", product.variants.nodes[0].id);
        html_element.find('.product_card_loading_overlay').attr("variant_id", product.variants.nodes[0].id);
        html_element.find('.product_card_action_buttons').attr("variant_id", product.variants.nodes[0].id);
        html_element.find('.quantity_badge').attr("variant_id", product.variants.nodes[0].id);
        html_element.find('.product_quantity').attr("variant_id", product.variants.nodes[0].id);
      }
      if(product.onlineStoreUrl != null && product.onlineStoreUrl != undefined && product.onlineStoreUrl != ""){
        html_element.find('.product_url').attr("href", product.onlineStoreUrl);
      } else {
        html_element.find('.product_url').attr("href", primaryDomainURL + "/products/" + product.handle);
      }
      
      html_element.addClass("col-lg-" + (12 / parseInt(settings.no_of_columns_desktop)));
      html_element.addClass("col-md-" + (12 / parseInt(settings.no_of_columns_tablet)));
      html_element.addClass("col-sm-" + (12 / parseInt(settings.no_of_columns_mobile)));


      //Cart Quantities
      var this_product_quantity = 0;
      var this_product_variant_quantity = {};
      for(var g = 0; g < product.variants.nodes.length; g++){
        this_product_variant_quantity[product.variants.nodes[g].id] = 0;
      }
      for(var g = 0; g < customerCart.lines.length; g++){
        if(customerCart.lines[g].merchandise.product.id == product.id){
          this_product_quantity += customerCart.lines[g].quantity;
          this_product_variant_quantity[customerCart.lines[g].merchandise.id] += customerCart.lines[g].quantity;
        }
      }
      
      html_element.find('.product_quantity').val(this_product_quantity);
      html_element.find('.quantity_badge').html(this_product_quantity);
      if(this_product_quantity > 0){
        if(product.variantsCount.count < 2){
          html_element.find('.custom-quantity-selector').css("display", "flex");
          html_element.find('.action-buttons').css("display", "none");
        }
      } else {
        html_element.find('.quantity_badge').hide();
      }
      product_cards.push(html_element);
    }
    
    if(settings.display_type == "slider"){
      $(".render_product_cards[section_id='" + settings.section_id + "']").fadeOut(300, function() {
        $(this).html("");
        $(this).html(product_cards);
        $(this).fadeIn(300);
        $(".render_product_cards[section_id='" + settings.section_id + "']").slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: settings.no_of_columns_desktop,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: settings.no_of_columns_desktop,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: settings.no_of_columns_tablet,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: settings.no_of_columns_mobile,
                slidesToScroll: 1
              }
            }
          ]
        });
        $(".render_product_cards[section_id='" + settings.section_id + "']").find('.product_card').css("padding", "10px")
      });
    } else {
      if(settings.pagination == "1" && settings.cursor != ""){
        $(".render_product_cards[section_id='" + settings.section_id + "']").append(product_cards);
        infiniteScrollLoading[settings.section_id] = false;
      } else {
        $(".render_product_cards[section_id='" + settings.section_id + "']").fadeOut(300, function() {
          $(this).html("");
          $(this).html(product_cards);
          $(this).fadeIn(300);
        });
      }
    }
  });
}

$(document).on("click",".no-location-set", function() {
    Notiflix.Notify.failure('You must add your address first!');
});
$(document).on('click', '.product_quick_add_button', async function(){
  var variant_id = $(this).attr('variant_id');
  var line_item_id = $(this).attr('line_item_id');
  var current_quantity = parseInt($(this).attr('current_quantity'));
  var action = $(this).attr('action');
  if($(this).hasClass('main-add') == true) {
    $(this).addClass('loading');
  } else {
    $(this).parents('.quantity-box').addClass('loading');
  }
  var newCart;
  if(action == "add"){
    newCart = await cartLinesAdd(variant_id, 1);
  } else {
    //Update
    newCart = await cartLinesUpdate(line_item_id, current_quantity - 1, attributes = [])
    if(current_quantity - 1 <= 0){
      $(this).parents(".cart-item").remove();
      if($('.cart-item').length == 0){
        var cart_item_html = `<div class="cart-item empty-cart">Your cart is empty</div>`;
        $('.total-cart-items').html(cart_item_html);
      }
    }
  }
  if($(this).hasClass('main-add') == true) {
    $(this).removeClass('loading');
  } else {
    $(this).parents('.quantity-box').removeClass('loading');
  }
  if(!newCart){
    Notiflix.Notify.failure("There was an error adding/removing product");
    return;
  }
  if(newCart.status != 1){
    return;
  }
  if (window.location.pathname === "/cart") {
    await cartPage(customerCart);
    executeProductQuantityUpdate();
  } else {
    await sideCartPage(customerCart);
    executeProductQuantityUpdate();
  }
})
async function executeProductQuantityUpdate(){
  if(!(customerCart && customerCart.lines)){
    await getCart();
  }
  if(customerCart && customerCart.lines){
    $(".product_card_quantity_box").addClass("quantity-no-box");
    $(".product_card_quantity_box").addClass("product_quick_add_button");
    $(".product_card_quantity_box").find(".card-open-qty.minus").removeClass("product_quick_add_button");
    $(".product_card_quantity_box").find(".card-open-qty.plus").removeClass("product_quick_add_button");
    $(".product_card_quantity_box").find(".product_quick_add_button").attr("current_quantity",0)
    $(".product_card_quantity_box").find(".product_quick_add_button").attr("line_item_id","")
    $(".product_card_quantity_box").find(".qty-number").html(0);
    $(".product_card_quantity_box").find(".qty-number").attr("current_quantity", 0);
    $(".product_card_quantity_box").find(".card-open-qty.plus").html("ADD TO CART");
    var total_cart_quantity = 0;
    for(var i = 0; i < customerCart.lines.length; i++){
      var variant_id = customerCart.lines[i].merchandise.id.replace(variant_identifier, "");
      var card = $(".product_card_quantity_box[variant_id='" + variant_id + "']");
      card.removeClass("quantity-no-box");
      card.removeClass("product_quick_add_button");
      card.find(".card-open-qty.minus").addClass("product_quick_add_button");
      card.find(".card-open-qty.plus").addClass("product_quick_add_button");
      card.find(".product_quick_add_button").attr("current_quantity", parseInt(customerCart.lines[i].quantity));
      card.find(".product_quick_add_button").attr("line_item_id", customerCart.lines[i].id.replace(cartLine_identifier, ""));
      card.find(".qty-number").html(parseInt(customerCart.lines[i].quantity));
      card.find(".qty-number").attr("current_quantity", parseInt(customerCart.lines[i].quantity));
      card.find(".product_quick_add_button.plus").html('<i class="bi bi-plus"></i>');
      total_cart_quantity += parseInt(customerCart.lines[i].quantity);
    }
    $(".cart-badge").html(total_cart_quantity);
    $(".cart-quantities").html(total_cart_quantity + " Items");
    printCartInformation();
  }
}

//Cart Page
async function cartPage(alfatah_cart){
  var getCatrProducts = await getCartProductInformation(alfatah_cart);
  var cart_item_html = '';
  if(getCatrProducts.length > 0){
      for(var i = 0; i < getCatrProducts.length; i++){
          var product_quantity = 0;
          var product_total_amount = 0;
          var product_sub_total_amount = '';
          var cart_line_item_id = "";
          for(var j = 0; j < alfatah_cart.lines.length; j++){
              if(alfatah_cart.lines[j].merchandise.id == getCatrProducts[i].id){
                  product_quantity = alfatah_cart.lines[j].quantity;
                  product_total_amount = alfatah_cart.lines[j].cost.totalAmount.amount;
                  //product_sub_total_amount = alfatah_cart.lines[j].cost.subtotalAmount.amount;
                  cart_line_item_id = alfatah_cart.lines[j].id.replace(cartLine_identifier, "");
                  break;
              }
          }
          var product = getCatrProducts[i];
          var variant_title = '<p class="item-brand" style="margin-bottom: 10px;"></p>';
          if(product.title != 'Default Title'){
              variant_title = `<p class="item-brand">${product.title}</p>`;
          }
          var badge_discount = '';
          var original_price = '';
          if((product.compareAtPriceV2 != undefined && product.compareAtPriceV2 != null) && parseFloat(product.compareAtPriceV2.amount) > parseFloat(product.priceV2.amount)){ 
              var discount_percentage = Math.round(((product.compareAtPriceV2.amount - product.priceV2.amount) / product.compareAtPriceV2.amount) * 100);
              badge_discount += `<span class="badge-discount">${discount_percentage}%</span>`;
              original_price = `<span class="original-price">${formatPrice(product.compareAtPriceV2.amount)}</span>`;
              product_sub_total_amount = `<span class="original-price">${formatPrice(parseFloat(product.compareAtPriceV2.amount)*parseFloat(product_quantity))}</span>`;
          }
          if(product.image == undefined || product.image == null || product.image.src == undefined || product.image.src == null) {
              product.image = {};
              product.image.src = no_product_image_url;
          }
          cart_item_html += `<div class="cart-item" variant_id = "${product.id.replace(variant_identifier,'')}">
              <div class="row g-3">
                  <div class="col-md-2 col-4">
                      <div class="item-image-container">
                          <img src="${product.image.src}" alt="${product.product.title}" class="item-image">
                          ${badge_discount}
                      </div>
                  </div>
                  <div class="col-md-10 col-8">
                      <p class="item-name"><a href = "${product.product.onlineStoreUrl}">${product.product.title}</a></p>`+variant_title+`
                      <p><span class="item-brand price"> ${formatPrice(product.priceV2.amount)} </span>
                      <span class="item-brand original-price"> ${original_price} </span></p>
                      <p class = "product_warnings_cart" variant_id = "${product.id.replace(variant_identifier,'')}">
                      </p>
                      <div class="quantity-control">
                          <div class="quantity-box product_card_quantity_box" variant_id = "${product.id.replace(variant_identifier,'')}">
                            <div class="product_add_loader"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></div>
                            <button class="btn-qty loading-none minus product_quick_add_button" current_quantity="${product_quantity}" variant_id = "${product.id.replace(variant_identifier,'')}" line_item_id = "` + cart_line_item_id + `" action = "update"><i class="bi bi-dash"></i></button>
                            <span class="qty-number loading-none" current_quantity="${product_quantity}">${product_quantity}</span>
                            <button class="btn-qty loading-none plus product_quick_add_button" current_quantity="${product_quantity}" variant_id = "${product.id.replace(variant_identifier,'')}" action = "add"><i class="bi bi-plus"></i></button>
                          </div>
                          <span class="price"> ${formatPrice(product_total_amount)} </span>
                          ${product_sub_total_amount}
                      </div>
                      
                      <div class="d-flex gap-2 align-items-center flex-wrap">
                          <span class="weight-badge remove_product_cart" variant_id = "${product.id.replace(variant_identifier,'')}">Remove</span>
                      </div>

                      <div class="item-actions">
                          <button class="action-btn">
                              <i class="far fa-heart"></i>
                          </button>
                          <button class="action-btn delete">
                              <i class="fas fa-trash-alt"></i>
                          </button>
                      </div>
                  </div>
              </div>
          </div>`;
      }
  } else {
    cart_item_html += `<div class="cart-item empty-cart">Your cart is empty</div>`;
  }
  $('.total-cart-items').html(cart_item_html);
  printCartInformation();
}
async function printCartInformation(){
  $(".order-sub-total").text(formatPrice(parseFloat(customerCart.cost.checkoutChargeAmount.amount).toFixed(2)));
  $(".order-sub-total").attr("sub-total-price", parseFloat(customerCart.cost.checkoutChargeAmount.amount).toFixed(2));
  $(".order-discount-total").text(formatPrice(parseFloat(customerCart.cost.checkoutChargeAmount.amount).toFixed(2) - parseFloat(customerCart.cost.totalAmount.amount).toFixed(2)));
  $(".order-gross-total").text(formatPrice(parseFloat(customerCart.cost.totalAmount.amount).toFixed(2)));
  $(".view-cart-sub").text(formatPrice(parseFloat(customerCart.cost.checkoutChargeAmount.amount).toFixed(2)));
  if(parseFloat(customerCart.cost.checkoutChargeAmount.amount).toFixed(2) != parseFloat(customerCart.cost.totalAmount.amount).toFixed(2)){
    $('.gross-total-row').removeClass("d-none");
    $('.discount-total-row').removeClass("d-none");
  }
}
$(document).on('click', '.remove_product_cart', function(){
  var variant_id = $(this).attr("variant_id");
  $(".product_quick_add_button[variant_id='" + variant_id + "']").attr("current_quantity", 1);
  $(".product_quick_add_button.minus[variant_id='" + variant_id + "']").click();
});
$(document).on('click', '.remove_all_cart_items', function(){
  Notiflix.Confirm.show(
    'Remove Items?',
    'This will remove all items from your cart. Are you sure you want to continue?',
    'Yes',
    'No',
    async () => {
        Notiflix.Loading.standard('Please wait...');
        await removeAllCartItems();
        window.location.reload();
        Notiflix.Loading.remove();
    },
    async () => {
        Notiflix.Loading.remove();
    },
    );
});

//Account Pages
async function accountPage(){
  Notiflix.Loading.standard('Please wait...');
  var customer = await getCustomer();
  var customerOrders = await getCustomerOrders();

  var displayName = customer.displayName;
  var initials_avatar = displayName
    .split(' ')
    .map(word => word.charAt(0).toUpperCase())
    .join('');

  if(customer){
    $(".customer_page_name").html(customer.displayName);
    $(".welcome-name").html("Welcome,"+ " " + customer.displayName);
    $(".created_at").html("Member Since,"+ " " + new Date(customer.creationDate).toLocaleString());
    $(".customer_page_email").html(customer.email);
    $(".customer_page_phone").html(customer.phone);
    $(".customer_page_member_since").html(new Date(customer.creationDate).toLocaleString());
    $(".profile-avatar").html(initials_avatar);
    $("#update_customer_first_name").val(customer.firstName);
    $("#update_customer_last_name").val(customer.lastName);
    var customer_addresses = '';
    if(customer.addresses != undefined && customer.addresses.length > 0) {
      for(var a = 0; a < customer.addresses.length; a++) {
        var address = customer.addresses[a];
        customer_addresses += `<div class="col-lg-4 col-md-6 mb-4">
            <div class="address-card">
                <h5 class="mb-3">${address.first_name} ${address.last_name}</h5>
                <p class="mb-2"><b>Phone: </b>${address.phone}</p>
                <p class="mb-2"><b>Address: </b>${address.address1}</p>
                <p class="mb-2"><b>House No, Apartment, suite, etc:</b> ${address.address2}</p>
                <p class="mb-2"><b>Area:</b> ${address.area}</p>
                <p class="mb-2"><b>City:</b> ${address.city}</p>
                <div class="gap-2" address_id="${address.id}">
                    <a address_id="${address.id}" class="btn btn-outline-danger w-100 delete-address">Delete</a>
                </div>
            </div>
        </div>`;
      }
      $(".customer-addressess").html(customer_addresses);
    } else {
      $(".customer-addressess").html('<div class="col-lg-12"> <div class="address-card text-center"><b>No Address Found</b></div></div>');
    }
    fetchPaymentMethods();
  }
  if(customerOrders){
    await printCustomerOrders(customerOrders);
    const target = document.getElementById('orders_page_pagination');
    let isLoading = false;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const ordersTab = document.getElementById('orders');
            if(entry.isIntersecting && !isLoading && ordersTab.classList.contains('show', 'active')){
                fetchNextPage(entry.target);
            }
        });
    }, { threshold: 0.1 });
    if(target) {
      observer.observe(target);
    }
  } else {
    $(".customer-order-cards .orders-grid").html('<div class="col-lg-12"> <div class="address-card text-center"><b>No Orders Found</b></div></div>');
  }
  Notiflix.Loading.remove();
}
$(document).on('click', '.delete-address', async function(){
  Notiflix.Confirm.show(
  'Delete Address?',
  'Do you want to delete this address?',
  'Yes',
  'No',
    async () => {
        Notiflix.Loading.standard('Please wait...');
        var customerAccessTokenCheck = localStorage.getItem('customer_access_token')
        if(customerAccessTokenCheck != null && customerAccessTokenCheck != "" && customerAccessTokenCheck != undefined){
          var address_id = $(this).attr('address_id');
          var customer = await getCustomer();
          var customerAddressess = customer.addresses;
          var updatedAddressess = [];
          for(var i = 0; i < customerAddressess.length; i++){
            if(customerAddressess[i].id != address_id){
              updatedAddressess.push(customerAddressess[i]);
            }
          }
          const response = await fetch('https://shopify.com/' + shopify_customer_shop_id + '/account/customer/api/2026-01/graphql',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: customerAccessTokenCheck,
              },
              body: JSON.stringify({
                query: `
                  mutation setCustomerMeta($metafields: [MetafieldsSetInput!]!) {
                    metafieldsSet(metafields: $metafields) {
                      metafields {
                        key
                        namespace
                        value
                        type
                      }
                      userErrors {
                        field
                        message
                      }
                    }
                  }
                `,
                variables: {
                  metafields: [
                    {
                      namespace: "custom",
                      key: "addresses",
                      type: "json",
                      ownerId: customer.id,
                      value: JSON.stringify(updatedAddressess),
                    }
                  ]
                }
              }),
            }
          );
          const result = await response.json();
          accountPage();
        }
        Notiflix.Loading.remove();
    },
    async () => {
        Notiflix.Loading.remove();
    },
  );
  
});
$(document).on('click', '#updateProfileInfoButton', async function(){
  var first_name = $("#update_customer_first_name").val();
  var last_name = $("#update_customer_last_name").val();
  if(!first_name || !last_name){
    Notiflix.Notify.failure("Please fill all fields");
    return;
  }
  Notiflix.Loading.standard('Please wait...');
  var customerAccessTokenCheck = localStorage.getItem('customer_access_token')
  if(customerAccessTokenCheck != null && customerAccessTokenCheck != "" && customerAccessTokenCheck != undefined){
    const response = await fetch('https://shopify.com/' + shopify_customer_shop_id + '/account/customer/api/2026-01/graphql',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: customerAccessTokenCheck,
        },
        body: JSON.stringify({
          query: `
            mutation customerUpdate($input: CustomerUpdateInput!) {
              customerUpdate(input: $input) {
                userErrors {
                  field
                  message
                }
                customer {
                  firstName
                  lastName
                }
              }
            }
          `,
          variables: {
            input: {
              "firstName": first_name,
              "lastName": last_name
            }
          }
        }),
      }
    );
    const result = await response.json();
    accountPage();
    $('#editAccountProfile').modal('hide');
  }
  Notiflix.Loading.remove();
});
async function fetchPaymentMethods(){
  return new Promise(async (resolve,reject) => {
    $(".customer-paymentMethods").html('<div class="col-lg-12"> <div class="address-card text-center"><b>Fetching, Please wait...</b></div></div>');
    var customerAccessToken = localStorage.getItem('customer_access_token');
    if(customerAccessToken != null && customerAccessToken != undefined && customerAccessToken != ''){
      fetch(paymentMethodsURL, {
          method: "POST",
          headers: {
              "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
          },
          body: new URLSearchParams({
              access_token: base64UrlEncode(customerAccessToken)
          })
      })
      .then(res => {
          if (!res.ok) throw new Error("Network error");
          return res.text();
      })
      .then(text => {
          const response = JSON.parse(text);
          if (response.status) {
            var jazzcash_wallets = response.payment_methods.jazzcash_wallets ?? [];
            var safepay_cards = response.payment_methods.safepay_cards ?? [];
            var saved_method_details = "";
            for(var i = 0; i < safepay_cards.length; i++){
              saved_method_details += `<div class="order-card">
                  <div class="order-number">**** **** **** ${safepay_cards[i].last_four}</div>
                  <div class="order-detail">
                      Expiry: ${safepay_cards[i].expiry_month}/${safepay_cards[i].expiry_year}
                  </div>
                  <div class="order-detail">
                      <span class="badge bg-info">${safepay_cards[i].type}</span>
                  </div>
                  <div class="order-detail-button"><btn token="` + safepay_cards[i].token + `" type = "safepay" class="btn btn-danger delete_payment_method">DELETE</btn></div>
              </div>`;
            }
            for(var i = 0; i < jazzcash_wallets.length; i++){
              saved_method_details += `<div class="order-card">
                  <div class="order-number">${jazzcash_wallets[i].account_number}</div>
                  <div class="order-detail">
                      <span class="badge bg-info">JAZZCASH</span>
                  </div>
                  <div class="order-detail-button"><btn token="` + jazzcash_wallets[i].token + `" type = "jazzcash" class="btn btn-danger delete_payment_method">DELETE</btn></div>
              </div>`;
            }
            $(".customer-paymentMethods").html(saved_method_details);
            if(safepay_cards.length == 0 && jazzcash_wallets.length == 0){
              $(".customer-paymentMethods").html(
                  '<div class="col-lg-12"><div class="address-card text-center"><b>No Payment Methods Found</b></div></div>'
              );
            }
            resolve();
            return;
          } else {
            $(".customer-paymentMethods").html(
                '<div class="col-lg-12"><div class="address-card text-center"><b>No Payment Methods Found</b></div></div>'
            );
            resolve();
            return;
          }
      })
      .catch(err => {
          console.error(err);
          $(".customer-paymentMethods").html(
              '<div class="col-lg-12"><div class="address-card text-center"><b>No Payment Methods Found</b></div></div>'
          );
          resolve();
      });
    } else {
      $(".customer-paymentMethods").html('<div class="col-lg-12"> <div class="address-card text-center"><b>No Payment Methods Found</b></div></div>');
      resolve();
      return;
    }
    
  });
}
$(document).on('click', '.delete_payment_method', async function(){
  Notiflix.Confirm.show(
  'Delete Payment Method?',
  'Do you want to delete this payment method?',
  'Yes',
  'No',
    async () => {
        Notiflix.Loading.standard('Please wait...');
        var customerAccessToken = localStorage.getItem('customer_access_token')
        if(customerAccessToken != null && customerAccessToken != "" && customerAccessToken != undefined){
          var type = $(this).attr('type');
          var token = $(this).attr('token');
          const response = await fetch(paymentMethodsURL + '/delete',
            {
              method: 'POST',
              headers: {
                  "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
              },
              body: new URLSearchParams({
                  access_token: base64UrlEncode(customerAccessToken),
                  token: token,
                  type: type,
              })
            }
          );
          const result = await response.json();
          if(result.status){
            Notiflix.Notify.success('Payment method deleted successfully!');
            $(".delete_payment_method[token='" + token + "']").parents(".order-card").remove();
          } else {
            Notiflix.Notify.failure('Unable to delete your payment method!');
          }
        }
        Notiflix.Loading.remove();
    },
    async () => {
        Notiflix.Loading.remove();
    },
  );
  
});

async function fetchNextPage(targetElement){
    isLoading = true;
    disableScroll();
    const hasOrders = targetElement.dataset.initialLoadDone === 'true';
    if(hasOrders) showLoader(targetElement);
    try {
        const endCursor = targetElement.getAttribute('endcursor');
        const customerOrdersPagination = await getCustomerOrders(endCursor);
        await printCustomerOrders(customerOrdersPagination);
        if(customerOrdersPagination.endCursor){
          targetElement.setAttribute('endcursor', customerOrdersPagination.endCursor);
        }
        targetElement.dataset.initialLoadDone = 'true';
    } catch(err) {
        console.error(err);
    } finally {
        hideLoader(targetElement);
        isLoading = false;
        enableScroll();
    }
}
function disableScroll() {
  document.body.style.overflow = 'hidden';
}
function enableScroll() {
  document.body.style.overflow = '';
}

// Example loader functions
function showLoader(targetElement) {
    let loader = document.getElementById('orders_loader');
    if (!loader) {
        loader = document.createElement('div');
        loader.id = 'orders_loader';
        loader.innerHTML = `
            <div class="spinner-grow text-success" role="status" style="margin-top:50px">
                <span class="visually-hidden">Loading...</span>
            </div>
        `;
        loader.style.position = 'absolute';
        loader.style.top = '50%';
        loader.style.left = '50%';
        loader.style.transform = 'translate(-50%, -50%)';
        loader.style.zIndex = '999';
        targetElement.style.position = 'relative';
        targetElement.appendChild(loader);
    }
    loader.style.display = 'block';
}
function hideLoader(targetElement) {
    const loader = document.getElementById('orders_loader');
    if (loader) loader.style.display = 'none';
}
async function printCustomerOrders(customerOrders){
  return new Promise((resolve,reject) => {
    var customer_order_details = '';
    if(customerOrders.orders.length > 0) {
      for(var o = 0; o < customerOrders.orders.length; o++) {
        var order = customerOrders.orders[o];
        var order_status = '';
        if(order.financialStatus == "PENDING") {
          order_status = '<span class="badge bg-warning">UNPAID</span>';
        } else  if(order.financialStatus == "PAID") {
            order_status = '<span class="badge bg-success">PAID</span>';
        } else  if(order.financialStatus == "PARTIALLY_PAID") {
            order_status = '<span class="badge bg-success">PARTIALLY PAID</span>';
        } else  if(order.financialStatus == "PARTIALLY_REFUNDED") {
            order_status = '<span class="badge bg-success">PARTIALLY REFUNDED</span>';
        } else  if(order.financialStatus == "REFUNDED") {
            order_status = '<span class="badge bg-warning">REFUNDED</span>';
        } else  if(order.financialStatus == "VOIDED") {
            order_status = '<span class="badge bg-danger">VOIDED</span>';
        } 
        var fullfilment_status = '';
        if(order.fulfillmentStatus == "FULFILLED") {
          fullfilment_status = '<span class="badge bg-success">FULFILLED</span>';
        } else if(order.fulfillmentStatus == "IN_PROGRESS") {
          fullfilment_status = '<span class="badge bg-primary">IN PROGRESS</span>';
        } else if(order.fulfillmentStatus == "ON_HOLD") {
          fullfilment_status = '<span class="badge bg-warning">ON HOLD</span>';
        } else if(order.fulfillmentStatus == "OPEN") {
          fullfilment_status = '<span class="badge bg-info">OPEN</span>';
        } else if(order.fulfillmentStatus == "PARTIALLY_FULFILLED") {
          fullfilment_status = '<span class="badge bg-success">PARTIALLY FULFILLED</span>';
        } else if(order.fulfillmentStatus == "PENDING_FULFILLMENT") {
          fullfilment_status = '<span class="badge bg-danger">PENDING FULFILLMENT</span>';
        }  else if(order.fulfillmentStatus == "RESTOCKED") {
          fullfilment_status = '<span class="badge bg-success">RESTOCKED</span>';
        } else if(order.fulfillmentStatus == "SCHEDULED") {
          fullfilment_status = '<span class="badge bg-info">SCHEDULED</span>';
        }  else if(order.fulfillmentStatus == "UNFULFILLED") {
          fullfilment_status = '<span class="badge bg-info">UNFULFILLED</span>';
        } 
        var order_email = order.email;
        var order_cart_id = order?.cart_id?.value ?? null;
        var order_secret_key = order?.order_secret_key?.value ?? null;
        var order_status_url = orderStatusURL;
        if(order_cart_id != null && order_cart_id != "" && order_secret_key != null && order_secret_key != ""){
            order_status_url += base64UrlEncode(order_cart_id) + "?key=" + base64UrlEncode(order_secret_key);
        } else {
            order_status_url += base64UrlEncode(order.id) + "?email=" + order_email;
        }
        customer_order_details += `<div class="order-card">
            <div class="order-number">Order  ${order.name}</div>
            <div class="order-detail">
                Placed on: ${new Date(order.createdAt).toLocaleString()}
            </div>
            <div class="order-detail">
                Total: ${formatPrice(order.totalPrice.amount)}
            </div>
            <div class="order-detail">
                ${order_status} &nbsp;&nbsp;
                ${fullfilment_status}
            </div>
            <div class="order-detail-button"><a href="` + order_status_url + `" target="_blank" class="btn btn-view">VIEW</a></div>
        </div>`;
      }
      $(".customer-order-cards .orders-grid").append(customer_order_details);
    } else {
      $(".customer-order-cards .orders-grid").html('<div class="col-lg-12"> <div class="address-card text-center"><b>No Orders Found</b></div></div>');
    }
    
    var endCursor = customerOrders.pageInfo.endCursor;
    var hasNextPage = customerOrders.pageInfo.hasNextPage;
    if(hasNextPage == true){
      $("#orders_page_pagination").attr("endCursor", endCursor);
    } else {
      $("#orders_page_pagination").remove();
    }
    resolve();
  });
}

//Execute
$( document ).ready(async function() {
    Notiflix.Loading.standard('Please wait...');
    var loginAccountCode = $.urlParam('code');
    var loginAccountState = $.urlParam('state');
    if (loginAccountState != "" && loginAccountState != undefined && loginAccountState != null && loginAccountCode != "" && loginAccountCode != undefined && loginAccountCode != null) {
      await processCustomerLogin(loginAccountCode, loginAccountState);
    }
    var sav_aff_info = $.urlParam('sav_aff_info');
    if (sav_aff_info != "" && sav_aff_info != undefined && sav_aff_info != null) {
      setCookie('sav_aff_info', sav_aff_info, 1);
    }
    var cart_recover = $.urlParam('cart_recover');
    var cart_recover_id = $.urlParam('cart_recover_id');
    if (cart_recover == 1 && cart_recover_id != null && cart_recover_id != "" && cart_recover_id != undefined) {
    	// setCookie('tech_andaz_checkout_id', atob(cart_recover_id.replace(/\/$/, '')), 1);
    	setCookie('tech_andaz_checkout_id', cart_recover_id, 1);
      window.history.replaceState(null, '', window.location.pathname);
      await getCart();
    } else {
      var cart_clear = $.urlParam('cart_reset');
      if (cart_clear == 1) {
    	  setCookie('tech_andaz_checkout_id', "", 1);
      }
      await createCart();
    }
    if (!Shopify.designMode) {
      getGeoLocation();
    }
    if (window.location.pathname === "/cart") {
        cartPage(customerCart);
    }
    if(cartLocation_order_method == "pickup"){
      createSelectedLocationMap("pickup_map", cartLocation_lat, cartLocation_long);
    } else if(cartLocation_order_method == "delivery" && cartLocation_google_address){
      createSelectedLocationMap("delivery_map", cartLocation_lat, cartLocation_long);
    }
    var customerAccessTokenCheck = localStorage.getItem('customer_access_token')
    if(customerAccessTokenCheck != null && customerAccessTokenCheck != "" && customerAccessTokenCheck != undefined){
      var customerInfo = await getCustomer();
      customerSavedAddresses = customerInfo.addresses;
      updateSavedAddresses(customerSavedAddresses);
      if (window.location.pathname === "/pages/account") {
          accountPage();
          if (window.location.hash && window.location.hash == "#payment-methods") {
              const tabBtn = document.querySelector('#payment-methods-tab');
              if (!tabBtn) return;
              const tab = new bootstrap.Tab(tabBtn);
              tab.show();
          }
      }
    }
    executeProductQuantityUpdate();
    Notiflix.Loading.remove();
});
$(document).on('click', '.alfatahLoginUser', function(){
  redirectToLogin();
});
$(document).on('click', '.alfatahLogoutUser', function(){
  logoutUser();
});
async function sideCartPage(alfatah_cart){
  var getCatrProducts = await getCartProductInformation(alfatah_cart);
  var cart_item_html = '';
  if(getCatrProducts.length > 0){
      for(var i = 0; i < getCatrProducts.length; i++){
          var product_quantity = 0;
          var product_total_amount = 0;
          var product_sub_total_amount = "";
          var cart_line_item_id = "";
          for(var j = 0; j < alfatah_cart.lines.length; j++){
              if(alfatah_cart.lines[j].merchandise.id == getCatrProducts[i].id){
                  product_quantity = alfatah_cart.lines[j].quantity;
                  product_total_amount = alfatah_cart.lines[j].cost.totalAmount.amount;
                 // product_sub_total_amount = alfatah_cart.lines[j].cost.subtotalAmount.amount;
                  cart_line_item_id = alfatah_cart.lines[j].id.replace(cartLine_identifier, "");
                  break;
              }
          }
          var product = getCatrProducts[i];
          var variant_title = '<div class="text-muted small mb-2"></div>';
          if(product.title != 'Default Title'){
              variant_title = `<div class="text-muted small mb-2">${product.title}</div>`;
          }
          var badge_discount = '';
          var original_price = '';
          if((product.compareAtPriceV2 != undefined && product.compareAtPriceV2 != null) && parseFloat(product.compareAtPriceV2.amount) > parseFloat(product.priceV2.amount)){ 
              var discount_percentage = Math.round(((product.compareAtPriceV2.amount - product.priceV2.amount) / product.compareAtPriceV2.amount) * 100);
              badge_discount += `<span class="badge-discount">${discount_percentage}%</span>`;
              original_price = `<span class="price-original ms-2">${formatPrice(product.compareAtPriceV2.amount)}</span>`;
              product_sub_total_amount = `<span class="price-original ms-2">${formatPrice(parseFloat(product.compareAtPriceV2.amount)*parseFloat(product_quantity))}</span>`;
          }
          if(product.image == undefined || product.image == null || product.image.src == undefined || product.image.src == null) {
              product.image = {};
              product.image.src = no_product_image_url;
          }
          cart_item_html += `<div class="border-bottom pb-3 mb-3">
              <div class="d-flex gap-3">
                  <div class="product-badge flex-shrink-0">
                      <div class="item-image-container">
                        <img src="${product.image.src}" alt="${product.product.title}" class="item-image img img-fluid img-thumbnail">
                    </div>
                  </div>
                  <div class="flex-grow-1">
                      <a href="${product.product.onlineStoreUrl}" class="product-link d-block mb-1">
                        ${product.product.title}
                      </a>
                      ${variant_title}
                      <p><span class="price-current current-top"> ${formatPrice(product.priceV2.amount)} </span>
                      ${original_price}
                      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2" style="margin-top:-19px">
                        <div class="quantity-control">
                            <div class="quantity-box product_card_quantity_box" variant_id = "${product.id.replace(variant_identifier,'')}">
                              <div class="product_add_loader"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></div>
                              <button class="btn-qty loading-none minus product_quick_add_button" current_quantity="${product_quantity}" variant_id = "${product.id.replace(variant_identifier,'')}" line_item_id = "` + cart_line_item_id + `" action = "update"><i class="bi bi-dash"></i></button>
                              <span class="qty-number loading-none" current_quantity="${product_quantity}">${product_quantity}</span>
                              <button class="btn-qty loading-none plus product_quick_add_button" current_quantity="${product_quantity}" variant_id = "${product.id.replace(variant_identifier,'')}" action = "add"><i class="bi bi-plus"></i></button>
                            </div>
                        </div>
                      </div>
                      <div class="mt-4">
                          <span class="price-current">${formatPrice(product_total_amount)}</span>
                          ${product_sub_total_amount}
                      </div>
                      <div class="remove-item-section mt-3">
                          <span class="weight-badge remove_product_cart" variant_id = "${product.id.replace(variant_identifier,'')}">Remove</span>
                      </div>
                  </div>
              </div>
          </div>`;
      }
  } else {
    cart_item_html += `<div class="cart-item empty-cart text-center side-cart-empty">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="200" height="200">
        <!-- Cart body -->
        <path d="M50 60 L60 120 L140 120 L150 60 Z" 
              fill="none" 
              stroke="#d1d5db" 
              stroke-width="3" 
              stroke-linecap="round" 
              stroke-linejoin="round"/>
        
        <!-- Cart handle -->
        <path d="M60 60 L70 40 L130 40 L140 60" 
              fill="none" 
              stroke="#d1d5db" 
              stroke-width="3" 
              stroke-linecap="round" 
              stroke-linejoin="round"/>
        
        <!-- Left wheel -->
        <circle cx="75" cy="135" r="8" 
                fill="none" 
                stroke="#d1d5db" 
                stroke-width="3"/>
        
        <!-- Right wheel -->
        <circle cx="125" cy="135" r="8" 
                fill="none" 
                stroke="#d1d5db" 
                stroke-width="3"/>
        
        <!-- Empty indicator - diagonal line -->
        <line x1="80" y1="75" x2="120" y2="105" 
              stroke="#d1d5db" 
              stroke-width="2" 
              stroke-linecap="round"
              opacity="0.6"/>
        
        <line x1="120" y1="75" x2="80" y2="105" 
              stroke="#d1d5db" 
              stroke-width="2" 
              stroke-linecap="round"
              opacity="0.6"/>
        
        <!-- Optional text -->
        <text x="100" y="170" 
              font-family="Arial, sans-serif" 
              font-size="14" 
              fill="#9ca3af" 
              text-anchor="middle">
          Your cart is empty
        </text>
      </svg>
    </div>`;
  }
  $('.side-cart-items').html(cart_item_html);
}
$(document).on('click', '.header-cart', async function(){
  if(window.location.pathname === "/cart") {
  } else {
    
    var cart_item_html = `<div class="cart-item empty-cart text-center side-cart-empty"><span class="spinner-border spinner-border-md" role="status" aria-hidden="true"></span></div>`;
    $('.side-cart-items').html(cart_item_html);
    $('#offcanvasCart').offcanvas('show');
    await getCart();
    var sideBarCart = await sideCartPage(customerCart);
    executeProductQuantityUpdate();
  }
});
$(document).on('click', '.btn-checkout', function(){
  window.location.href = '/cart';
});